import type { StoryNode } from '@/engine/types'

import { bondEndingNode } from './bondEnding'
import { cgPath } from '../cgAssets'

// 二组线检验首领是否能约束高层、承担外交后果，并在拒绝激将后仍保住真实战力。
export const route2Nodes = [
  {
    id: 'r2-00-founded',
    chapter: 'prologue',
    actLabel: '序章 · 江南是谁的江南',
    date: '2026-07-19',
    title: '江南成立',
    location: '组织大厅',
    mode: 'system',
    speaker: 'system',
    text: '组织「江南」创建成功。首领：{{player}}。高层：辰逸、岸。核心战力：夏娜。系统没有“共同创建者”这一职位，于是最难解释的关系被安排在了职位表之外。',
    background: 'organization',
    music: 'groupChat',
    sound: 'notice',
    historical: 'adapted',
    onEnter: [
      { type: 'highCouncil', members: ['chenyi', 'an'] },
      { type: 'stance', character: 'shana', value: 'support' },
      { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
    ],
    next: 'r2-01-shana-contract',
  },
  {
    id: 'r2-01-shana-contract',
    chapter: 'prologue',
    actLabel: '序章 · 江南是谁的江南',
    date: '2026-07-19',
    location: '江南 · 管理私聊',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '我可以告诉你哪场架打得赢。至于要不要打、谁有权限，你来定。以后别在公告里写“大家商量决定”——最后点确认的只有一个人。',
    background: 'organization',
    historical: 'fictional',
    presentation: {
      cg: cgPath('cg42-jiangnan-planning'),
      cgAlt: '夏娜在七月夜晚的桌边与玩家商量江南的管理边界',
      ui: 'classic',
      transition: 'ink',
      camera: 'push-in',
      atmosphere: 'none',
      focus: 'center',
    },
    onEnter: [{ type: 'unlockCg', id: 'cg42-jiangnan-planning' }],
    choices: [
      {
        id: 'own-decisions',
        label: '“建议你给，决定我来签。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'relationship', character: 'shana', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'shana', value: 35 },
          { type: 'flag', key: 'acceptedLeaderResponsibility' },
        ],
        next: 'r2-01a-own-decisions-reply',
      },
      {
        id: 'share-blame',
        label: '“真出事时，你也得替我说话。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'stance', character: 'shana', value: 'watch' },
        ],
        next: 'r2-01b-share-blame-reply',
      },
    ],
  },
  {
    id: 'r2-01a-own-decisions-reply', chapter: 'prologue', actLabel: '序章 · 江南是谁的江南', date: '2026-07-19',
    location: '江南 · 管理私聊', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '行。我的建议会写清胜率和代价，最后那行决定由你发；出事时也别把签名藏到“大家”后面。',
    background: 'organization', historical: 'fictional', next: 'r2-02-shi-arrives',
  },
  {
    id: 'r2-01b-share-blame-reply', chapter: 'prologue', actLabel: '序章 · 江南是谁的江南', date: '2026-07-19',
    location: '江南 · 管理私聊', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '我会替事实说话，不会替你分掉首领的责任。你要的是一起承担，就先把各自签哪一行说清。',
    background: 'organization', historical: 'fictional', next: 'r2-02-shi-arrives',
  },
  {
    id: 'r2-02-shi-arrives',
    chapter: 'prologue',
    actLabel: '序章 · 江南是谁的江南',
    date: '2026-07-19',
    title: '时加入江南',
    location: '成员申请',
    mode: 'system',
    speaker: 'system',
    text: '成员「时」加入组织。原所属：未闻花名。原职位：高层。当前职位：成员。跨组织履历没有自动兑换成管理权限。',
    background: 'organization',
    sound: 'notice',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg31-shi-joins-org2'),
      cgAlt: '7月19日，时把五组旧徽章收起，以普通成员身份进入江南，夏娜在高层席位前观察',
      ui: 'classic',
      transition: 'crossfade',
      camera: 'push-in',
      atmosphere: 'dust',
      focus: 'left',
    },
    onEnter: [
      { type: 'flag', key: 'shiJoinedOrg2OnJuly19' },
      { type: 'unlockCg', id: 'cg31-shi-joins-org2' },
    ],
    choices: [
      {
        id: 'welcome-with-boundary',
        label: '“欢迎。先按普通成员来，权限以后再谈。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'shi', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'flag', key: 'shiObservationPeriod' },
        ],
        next: 'r2-02a-observation-reply',
      },
      {
        id: 'promise-promotion',
        label: '私聊时透一句：“位置不会让你等太久。”',
        tone: 'bold',
        effects: [
          { type: 'relationship', character: 'shi', key: 'trust', value: 1 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: -1 },
          { type: 'relationship', character: 'an', key: 'trust', value: -1 },
          { type: 'flag', key: 'promisedShiPromotion' },
        ],
        next: 'r2-02b-promotion-reply',
      },
    ],
  },
  {
    id: 'r2-02a-observation-reply', chapter: 'prologue', actLabel: '序章 · 江南是谁的江南', date: '2026-07-19',
    location: '成员申请', mode: 'chat', speaker: 'shi', portrait: 'shi',
    text: '可以。我把五组的徽章收起来，先按江南普通成员做事；观察期结束时，请直接告诉我差在哪。',
    background: 'organization', historical: 'fictional', next: 'r2-03-normal-chat',
  },
  {
    id: 'r2-02b-promotion-reply', chapter: 'prologue', actLabel: '序章 · 江南是谁的江南', date: '2026-07-19',
    location: '成员申请', mode: 'chat', speaker: 'shi', portrait: 'shi',
    text: '我听见了，但别把这句当成已经发下来的权限。真要升我，就让现在坐在位置上的人也看见理由。',
    background: 'organization', historical: 'fictional', next: 'r2-03-normal-chat',
  },
  {
    id: 'r2-03-normal-chat',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '一段正常聊天',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '周一追击谁统计一下？我先把能上线的记了。',
    background: 'mutedKey',
    music: 'groupChat',
    historical: 'fictional',
    next: 'r2-03a-swordheart-roster',
  },
  {
    id: 'r2-03a-swordheart-roster',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南 · 出勤表',
    mode: 'chat',
    speaker: 'swordheart',
    portrait: 'swordheart',
    text: '大古统计追击，我把缺的晚场补上了。别给我管理权限，我只要你把名单最后一列写清：到了算到，没到别替谁圆。',
    background: 'mutedKey',
    historical: 'fictional',
    choices: [
      {
        id: 'accept-roster-result',
        label: '“你按自己的表走，明早把结果给我。”',
        tone: 'calm',
        effects: [{ type: 'relationship', character: 'swordheart', key: 'trust', value: 1 }],
        next: 'r2-03b-roster-delegated-reply',
      },
      {
        id: 'check-roster-together',
        label: '拉开表格：“最后一列，我们一起核。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'swordheartRosterChecked' },
          { type: 'relationship', character: 'swordheart', key: 'trust', value: 2 },
          { type: 'relationship', character: 'swordheart', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'swordheart', value: 35 },
        ],
        next: 'r2-03c-roster-together-reply',
      },
    ],
  },
  {
    id: 'r2-03b-roster-delegated-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '江南 · 出勤表', mode: 'chat', speaker: 'swordheart', portrait: 'swordheart',
    text: '好，我按自己的表核，明早只交结果。漏谁算我的，别在结算后替我补一句“应该到了”。',
    background: 'mutedKey', historical: 'fictional', next: 'r2-04-chenyi-pings',
  },
  {
    id: 'r2-03c-roster-together-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '江南 · 出勤表', mode: 'chat', speaker: 'swordheart', portrait: 'swordheart',
    text: '那就一起核。你看确认记录，我看上线时间；最后一列谁都别凭关系改。',
    background: 'mutedKey', historical: 'fictional', next: 'r2-04-chenyi-pings',
  },
  {
    id: 'r2-04-chenyi-pings',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: 'takemehand？刚才问你话了。\n@takemehand\n人呢？高层说话看不到？',
    background: 'mutedKey',
    sound: 'message',
    historical: 'adapted',
    next: 'r2-04a-jealous-ping',
  },
  {
    id: 'r2-04a-jealous-ping',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '你刚才明明回了大古。轮到我就没看见？\n行，不想理我就直说。',
    background: 'mutedKey',
    sound: 'message',
    historical: 'adapted',
    next: 'r2-05-muted',
  },
  {
    id: 'r2-05-muted',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '被按下的发言键',
    location: '江南组织群',
    mode: 'system',
    speaker: 'system',
    text: '管理员「辰逸」已将成员「takemehand」设为禁言。原因栏为空；上一条消息还停在“不想理我就直说”。',
    background: 'mutedKey',
    music: 'worldEnemy',
    sound: 'warning',
    historical: 'confirmed',
    // The confirmed mute is promoted to an explicit event CG; nearby chat nodes keep the same art as continuity.
    presentation: {
      cg: '/assets/backgrounds/galgame/muted-key-v1.webp',
      cgAlt: '辰逸因未得到回应而按下管理员禁言，takemehand尚未意识到权限已被动用',
      ui: 'cinematic',
      transition: 'flash',
      atmosphere: 'messages',
      focus: 'right',
    },
    onEnter: [
      { type: 'flag', key: 'takemehandMuted' },
      { type: 'unlockCg', id: 'cg01-muted-key' },
    ],
    next: 'r2-05a-muted-discovered',
  },
  {
    id: 'r2-05a-muted-discovered',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '私聊',
    mode: 'chat',
    speaker: 'takemehand',
    portrait: 'takemehand',
    text: '我刚切回来，输入框就灰了。因为没回他？\n你先别让他删记录，我要知道这个权限是不是想按就按。',
    background: 'mutedKey',
    sound: 'message',
    historical: 'adapted',
    next: 'r2-06-first-ruling',
  },
  {
    id: 'r2-06-first-ruling',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南组织群',
    mode: 'novel',
    speaker: 'shana',
    portrait: 'shana',
    text: '先别问他为什么没回。现在的问题是：不回消息，够不够高层动权限？你是首领，你先回答。',
    background: 'mutedKey',
    historical: 'fictional',
    choices: [
      {
        id: 'publish-rule',
        label: '点下解除禁言：“以后禁言要写明理由。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'muteHandledByRule' },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'takemehand', key: 'trust', value: 2 },
          { type: 'relationship', character: 'takemehand', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'takemehand', value: 60 },
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: -1 },
        ],
        next: 'r2-07-rule-result',
      },
      {
        id: 'private-mediation',
        label: '先解除禁言，再分别拨通两人的语音',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'muteHandledPrivately' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'relationship', character: 'takemehand', key: 'trust', value: 1 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 1 },
        ],
        next: 'r2-07-private-result',
      },
      {
        id: 'support-chenyi',
        label: '“先维持处理。高层点名必须回应。”',
        tone: 'danger',
        effects: [
          { type: 'flag', key: 'supportedChenyiMute' },
          { type: 'flag', key: 'takemehandLeftOrg2' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'stat', key: 'reputation', value: -2 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 2 },
          { type: 'relationship', character: 'takemehand', key: 'trust', value: -2 },
          { type: 'stance', character: 'takemehand', value: 'left' },
          { type: 'organizationRelation', organization: 'org4', value: -1 },
        ],
        next: 'r2-07-support-result',
      },
      {
        id: 'demote-immediately',
        label: '撤下辰逸权限：“先停手，再说原因。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'chenyiDemotedEarly' },
          { type: 'flag', key: 'chenyiDemoted' },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'relationship', character: 'takemehand', key: 'trust', value: 2 },
          { type: 'relationshipProgress', character: 'takemehand', value: 60 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: -2 },
          { type: 'stance', character: 'chenyi', value: 'oppose' },
        ],
        next: 'r2-07-demote-result',
      },
    ],
  },
  {
    id: 'r2-07-rule-result',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'takemehand',
    portrait: 'takemehand',
    text: '我不要求你当众骂谁。我只想确认：以后高层没等到回复，还能不能直接禁言？你把答案写出来，我就先留下。',
    background: 'mutedKey',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'takemehandStayedOrg2' }],
    next: 'r2-07e-chenyi-account-one',
  },
  {
    id: 'r2-07-private-result',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '私聊',
    mode: 'chat',
    speaker: 'takemehand',
    portrait: 'takemehand',
    text: '你解了禁言，但群里没人知道规则有没有变。我会把记录留着。去不去四组，我再看。',
    background: 'mutedKey',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'takemehandConsideringExit' }],
    next: 'r2-07e-chenyi-account-one',
  },
  {
    id: 'r2-07-support-result',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '成员列表',
    mode: 'system',
    speaker: 'system',
    text: '成员「takemehand」退出组织「江南」，随后加入「天上白玉京」。辰逸得到了一次回应，只不过它出现在退组通知里。',
    background: 'mutedKey',
    sound: 'notice',
    historical: 'confirmed',
    presentation: {
      ui: 'classic', transition: 'ink', camera: 'pull-back', atmosphere: 'messages',
      sprites: [
        { character: 'chenyi', expression: 'determined', pose: 'phone', position: 'left', dimmed: true },
        { character: 'takemehand', expression: 'sad', pose: 'base', position: 'right', scale: 1.03 },
      ],
    },
    next: 'r2-07e-chenyi-account-one',
  },
  {
    id: 'r2-07-demote-result',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '连原因都不让我说，就先撤我？外面的人以后是不是只要装没看见，高层都不能管？',
    background: 'mutedKey',
    sound: 'warning',
    historical: 'fictional',
    next: 'r2-07e-chenyi-account-one',
  },
  {
    id: 'r2-07e-chenyi-account-one',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '辰逸 · 私聊',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '你是来问我为什么禁言，还是来通知我大家已经给我定性了？先说好，我现在听见“冷静”两个字就更想打字。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'name-permission-harm',
        label: '“先说你在气什么，再说权限该不该动。”',
        tone: 'calm',
        effects: [
          { type: 'relationshipProgress', character: 'chenyi', value: 35 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 2 },
          { type: 'relationship', character: 'chenyi', key: 'affinity', value: 1 },
          { type: 'flag', key: 'chenyiNamedJealousy' },
        ],
        next: 'r2-07f-chenyi-admits-jealousy',
      },
      {
        id: 'call-it-misunderstanding',
        label: '“群里都在气头上，就当一次误会吧。”',
        tone: 'warm',
        effects: [{ type: 'relationship', character: 'chenyi', key: 'trust', value: -1 }],
        next: 'r2-07g-chenyi-keeps-excuse',
      },
    ],
  },
  {
    id: 'r2-07f-chenyi-admits-jealousy',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '辰逸 · 私聊',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '……我当时就是嫉妒：他回了大古，没回我，我就觉得自己这个高层像个笑话。说白了，是我心智不成熟。禁言不是管理，是我拿权限逼他看我。你可以记进处理记录，别替我删。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-08-screenshot',
  },
  {
    id: 'r2-07g-chenyi-keeps-excuse',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '辰逸 · 私聊',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '那就写误会。反正公告里两个字，谁都不用承认自己干了什么。只是下次再有人不回我，你最好比禁言按钮先出现。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-08-screenshot',
  },
  {
    id: 'r2-08-screenshot',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '截图开始旅行',
    location: '4945区群',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '老区一般这种事私下说两句就完了。……等等，这张图怎么已经到四组了？而且开头少了三行。',
    background: 'worldChat',
    music: 'worldEnemy',
    historical: 'adapted',
    choices: [
      {
        id: 'release-context',
        label: '把带时间的完整记录发进区群',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'evidence', value: 2 },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'organizationRelation', organization: 'org4', value: 1 },
          { type: 'relationship', character: 'takemehand', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'takemehand', value: 40 },
          { type: 'flag', key: 'releasedFullContext' },
        ],
        next: 'r2-08a-full-context-reply',
      },
      {
        id: 'release-favorable',
        label: '只截下“已解禁”的那一段',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'flag', key: 'releasedPartialContext' },
          { type: 'relationship', character: 'truth', key: 'trust', value: -1 },
        ],
        next: 'r2-08b-partial-context-reply',
      },
      {
        id: 'keep-internal',
        label: '收起截图，只发一句“内部已处理”',
        tone: 'secret',
        effects: [
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'stat', key: 'reputation', value: -1 },
          { type: 'flag', key: 'keptContextInternal' },
        ],
        next: 'r2-08c-internal-context-reply',
      },
    ],
  },
  {
    id: 'r2-08a-full-context-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'mentor', portrait: 'mentor',
    text: '完整记录发出去了，开头三行和解禁时间都在。接下来谁截一半说话，至少所有人能回原图核。',
    background: 'worldChat', historical: 'fictional', next: 'r2-09-world-enemy-starts',
  },
  {
    id: 'r2-08b-partial-context-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '这张图只剩对你有利的一段。我会在存档里标“前文缺失”；别人追问时，第一句就是这部分没有证据。',
    background: 'worldChat', historical: 'fictional', next: 'r2-09-world-enemy-starts',
  },
  {
    id: 'r2-08c-internal-context-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '江南管理群', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '内部记录我收了。外面只看见“已处理”，不会因此停止猜；你选择的是先保住组织群，后面要自己接解释。',
    background: 'worldChat', historical: 'fictional', next: 'r2-09-world-enemy-starts',
  },
  {
    id: 'r2-09-world-enemy-starts',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '与世界为敌',
    location: '4945区群',
    mode: 'interlude',
    speaker: 'narrator',
    text: '当天稍晚，辰逸把争论带到公共群。他先与一组首领争执，三组和四组首领加入后，句子里的主语从“我”逐渐变成了“我们二组”。',
    background: 'worldChat',
    music: 'worldEnemy',
    sound: 'warning',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg27-world-enemy'),
      cgAlt: '7月20日，辰逸把个人权限争议带进4945区公共群，发言流同时指向一、三、四组',
      ui: 'cinematic',
      transition: 'glitch',
      camera: 'pull-back',
      atmosphere: 'messages',
      focus: 'left',
    },
    onEnter: [
      { type: 'flag', key: 'worldEnemyStartedOnJuly20' },
      { type: 'unlockCg', id: 'cg27-world-enemy' },
    ],
    next: {
      cases: [
        { when: { type: 'flag', key: 'releasedFullContext' }, next: 'r2-09a-full-context-echo' },
        { when: { type: 'flag', key: 'releasedPartialContext' }, next: 'r2-09b-partial-context-echo' },
        { when: { type: 'flag', key: 'keptContextInternal' }, next: 'r2-09c-internal-context-echo' },
      ],
      fallback: 'r2-10-chenyi-public',
    },
  },
  {
    id: 'r2-09a-full-context-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '原图我看完了。江南至少把时间线放全，接下来讨论谁越界，不用再猜开头三行。',
    background: 'worldChat', historical: 'fictional', next: 'r2-10-chenyi-public',
  },
  {
    id: 'r2-09b-partial-context-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '你发的图缺开头。二组要我判断组织立场，就把完整时间线补齐；不然我只按公开部分问责。',
    background: 'worldChat', historical: 'fictional', next: 'r2-10-chenyi-public',
  },
  {
    id: 'r2-09c-internal-context-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '二组只说内部处理，我就只能按公频上发生的事继续问。沉默没有把组织立场从现场拿走。',
    background: 'worldChat', historical: 'fictional', next: 'r2-10-chenyi-public',
  },
  {
    id: 'r2-10-chenyi-public',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '4945区群',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '一个个都来替人出头？一组、三组、四组都觉得二组好欺负是吧。别把我说的话摘出去，又回来问江南什么意思。',
    background: 'worldChat',
    historical: 'adapted',
    presentation: {
      cg: cgPath('cg27-world-enemy'),
      cgAlt: '辰逸站在交错的公共消息流前，把个人争执说成整个江南组织的立场',
      ui: 'classic',
      transition: 'crossfade',
      camera: 'push-in',
      atmosphere: 'messages',
      focus: 'left',
    },
    next: 'r2-11-three-leaders',
  },
  {
    id: 'r2-11-three-leaders',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '4945区群',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '既然他用二组高层身份在公共群发言，请二组首领说明：这是个人言论，还是组织立场？',
    background: 'worldChat',
    historical: 'adapted',
    choices: [
      {
        id: 'apologize-demote',
        label: '“这件事江南道歉。辰逸降为成员。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'chenyiDemoted' },
          { type: 'flag', key: 'org2Apologized' },
          { type: 'stat', key: 'reputation', value: 2 },
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: -2 },
          { type: 'organizationRelation', organization: 'org1', value: 1 },
        ],
        next: 'r2-11a-apology-reply',
      },
      {
        id: 'demote-no-collective-guilt',
        label: '“辰逸降级，但江南成员不用替他认错。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'chenyiDemoted' },
          { type: 'flag', key: 'refusedCollectiveGuilt' },
          { type: 'stat', key: 'reputation', value: 1 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'relationship', character: 'shana', key: 'trust', value: 2 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: -1 },
        ],
        next: 'r2-11b-no-collective-guilt-reply',
      },
      {
        id: 'defend-chenyi',
        label: '“他是在替江南说话。别再围着二组问。”',
        tone: 'danger',
        effects: [
          { type: 'flag', key: 'chenyiKeptExecutive' },
          { type: 'flag', key: 'worldEnemyEscalated' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'stat', key: 'reputation', value: -2 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 2 },
          { type: 'relationship', character: 'shana', key: 'trust', value: -2 },
          { type: 'stance', character: 'shana', value: 'oppose' },
          { type: 'organizationRelation', organization: 'org1', value: -2 },
          { type: 'organizationRelation', organization: 'org3', value: -2 },
          { type: 'organizationRelation', organization: 'org4', value: -2 },
        ],
        next: 'r2-11c-defend-chenyi-reply',
      },
      {
        id: 'publish-deadline',
        label: '把记录置顶：“两小时后，我给完整结论。”',
        tone: 'secret',
        condition: { type: 'stat', key: 'evidence', operator: 'gte', value: 2 },
        effects: [
          { type: 'flag', key: 'chenyiDemoted' },
          { type: 'flag', key: 'investigationDelivered' },
          { type: 'stat', key: 'reputation', value: 2 },
          { type: 'relationship', character: 'truth', key: 'trust', value: 2 },
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
        ],
        next: 'r2-11d-deadline-reply',
      },
    ],
  },
  {
    id: 'r2-11a-apology-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '收到。江南公开道歉、辰逸降级，我会把这两件事分开记；接下来按你们实际执行看。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12-ruling-aftermath',
  },
  {
    id: 'r2-11b-no-collective-guilt-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '这句边界够清楚：高层犯事由权限负责人处理，普通成员不替他认错。现在把降级真的执行。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12-ruling-aftermath',
  },
  {
    id: 'r2-11c-defend-chenyi-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '那我按江南组织立场记录。你替他把个人发言接成二组决定，之后的组织关系后果也由二组承担。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12-ruling-aftermath',
  },
  {
    id: 'r2-11d-deadline-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '4945区群', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '两小时截止我记下了。完整记录、权限处理和结论缺一项，我会在置顶下面标出来。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12-ruling-aftermath',
  },
  {
    id: 'r2-12-ruling-aftermath',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南 · 管理频道',
    mode: 'chat',
    speaker: 'sixin',
    portrait: 'sixin',
    text: '公告我看完了。我只问一句：这套规则下次高层犯事还算不算数？周六能上线的顺便报一下。',
    background: 'worldChat',
    historical: 'fictional',
    next: {
      cases: [
        { when: { type: 'flag', key: 'org2Apologized' }, next: 'r2-12c-apology-echo' },
        { when: { type: 'flag', key: 'refusedCollectiveGuilt' }, next: 'r2-12d-boundary-echo' },
        { when: { type: 'flag', key: 'chenyiKeptExecutive' }, next: 'r2-12e-defense-echo' },
        { when: { type: 'flag', key: 'investigationDelivered' }, next: 'r2-12f-investigation-echo' },
      ],
      fallback: 'r2-12a-shana-private',
    },
  },
  {
    id: 'r2-12c-apology-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '江南 · 管理频道', mode: 'chat', speaker: 'sixin', portrait: 'sixin',
    text: '道歉已经发出，降级名单也同步了。下次高层犯事，我会拿这次的处理顺序来问。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12a-shana-private',
  },
  {
    id: 'r2-12d-boundary-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '江南 · 管理频道', mode: 'chat', speaker: 'sixin', portrait: 'sixin',
    text: '普通成员不用替高层认错，这句我置顶了；但降级执行和权限回收仍由管理组负责。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12a-shana-private',
  },
  {
    id: 'r2-12e-defense-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '江南 · 管理频道', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '你保住了辰逸的权限，也把他的公频发言接成组织立场。今晚先关掉其他按钮，别让第二个人继续放大。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12a-shana-private',
  },
  {
    id: 'r2-12f-investigation-echo', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '江南 · 管理频道', mode: 'chat', speaker: 'truth', portrait: 'truth',
    text: '完整结论按时发了，缺失记录也标出来了。以后谁说江南只靠站队，可以直接回这份处理表。',
    background: 'worldChat', historical: 'fictional', next: 'r2-12a-shana-private',
  },
  {
    id: 'r2-12a-shana-private',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '夏娜 · 私聊',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '别再解释。先把高层权限关到最低，截图备份。你现在最缺的，是一分钟没人继续按按钮。',
    background: 'nightMessage',
    sound: 'message',
    historical: 'fictional',
    next: 'r2-12b-chenyi-account-two',
  },
  {
    id: 'r2-12b-chenyi-account-two',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南 · 处理记录',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '降级、道歉、截图，三件套齐了。你要我再写一份检讨吗？我可以写得很像，网上有模板，连标点都替我后悔。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'ask-for-account-not-template',
        label: '“不要模板。把你做的三件事按时间写清楚。”',
        tone: 'calm',
        effects: [
          { type: 'relationshipProgress', character: 'chenyi', value: 35 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 2 },
          { type: 'relationship', character: 'chenyi', key: 'affinity', value: 1 },
          { type: 'flag', key: 'chenyiRecordedConsequences' },
        ],
        next: 'r2-12c-chenyi-writes-record',
      },
      {
        id: 'blame-public-pressure',
        label: '“外面也有人拱火，你只是没忍住。”',
        tone: 'warm',
        effects: [{ type: 'relationship', character: 'chenyi', key: 'affinity', value: 1 }],
        next: 'r2-12d-chenyi-borrows-excuse',
      },
    ],
  },
  {
    id: 'r2-12c-chenyi-writes-record',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南 · 处理记录',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '第一，我因为没被搭理动了权限。第二，我把个人争执说成二组立场。第三，别人追问时我继续顶。降级不是他们赢，是这三件事该有后果。……这版不用替我润色。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-13-an-resigns',
  },
  {
    id: 'r2-12d-chenyi-borrows-excuse',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南 · 处理记录',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '那我就写“受到挑衅，情绪失控”。挺好，主语看着像我，责任读着像天气。你要是满意，我也可以满意。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-13-an-resigns',
  },
  {
    id: 'r2-13-an-resigns',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '另一个高层位置',
    location: '私聊',
    mode: 'chat',
    speaker: 'an',
    portrait: 'an',
    text: '先说清楚，我不是因为这次事被罚。我就是不想当高层了。需要交接可以，别把我写进“大清洗”公告。',
    background: 'organization',
    historical: 'adapted',
    // The same room continues into the appointment decision; one CG turns the handoff into a visible event.
    presentation: {
      cg: cgPath('cg28-council-reshuffle'),
      cgAlt: '岸主动交还高层权限，空出的管理席与普通成员大古同时出现在江南会议室里',
      ui: 'classic',
      transition: 'crossfade',
      camera: 'push-in',
      atmosphere: 'dust',
      focus: 'center',
    },
    onEnter: [{ type: 'unlockCg', id: 'cg28-council-reshuffle' }],
    choices: [
      {
        id: 'accept-resignation',
        label: '“可以。今晚把权限交给我，你安心当成员。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'anSteppedDownVoluntarily' },
          { type: 'relationship', character: 'an', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
        ],
        next: 'r2-13a-daigu-before-promotion',
      },
      {
        id: 'force-transition',
        label: '“先帮我撑到周六，要塞后我亲自接手。”',
        tone: 'danger',
        effects: [
          { type: 'flag', key: 'anForcedToStayTemporarily' },
          { type: 'relationship', character: 'an', key: 'trust', value: -2 },
          { type: 'stat', key: 'resources', value: 1 },
        ],
        next: 'r2-13a-daigu-before-promotion',
      },
    ],
  },
  {
    id: 'r2-13a-daigu-before-promotion',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    location: '江南 · 管理频道',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '我之前就是普通成员，也没预定过这个位置。真要让我接，先把谁能禁言、谁能踢人写清楚。',
    background: 'organization',
    historical: 'adapted',
    next: 'r2-14-council-choice',
  },
  {
    id: 'r2-14-council-choice',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '两张空椅子',
    location: '组织管理',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '岸的位置今晚收回。辰逸如果还留着，就只补一个；不留，就现在选两个。快点。',
    background: 'organization',
    historical: 'adapted',
    presentation: {
      cg: cgPath('cg28-council-reshuffle'),
      cgAlt: '江南会议室的两张管理席空着，夏娜等待玩家决定新的高层名单',
      ui: 'classic',
      transition: 'crossfade',
      camera: 'drift-right',
      atmosphere: 'dust',
      focus: 'center',
    },
    choices: [
      {
        id: 'appoint-shi-daigu',
        label: '把时和大古拉进管理群',
        tone: 'calm',
        effects: [
          { type: 'highCouncil', members: ['shi', 'daigu'] },
          { type: 'flag', key: 'appointedShiAndDaigu' },
          { type: 'relationship', character: 'shi', key: 'trust', value: 1 },
          { type: 'relationship', character: 'daigu', key: 'trust', value: 2 },
          { type: 'stat', key: 'resources', value: 1 },
        ],
        next: 'r2-14a-shi-daigu-reply',
      },
      {
        id: 'appoint-daigu-sixin',
        label: '把大古和死辛拉进管理群',
        tone: 'warm',
        effects: [
          { type: 'highCouncil', members: ['daigu', 'sixin'] },
          { type: 'relationship', character: 'daigu', key: 'trust', value: 2 },
          { type: 'relationship', character: 'sixin', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 1 },
        ],
        next: 'r2-14b-daigu-sixin-reply',
      },
      {
        id: 'keep-chenyi-appoint-daigu',
        label: '保留辰逸，只把大古补进空位',
        tone: 'danger',
        condition: { type: 'flag', key: 'chenyiKeptExecutive' },
        effects: [
          { type: 'highCouncil', members: ['chenyi', 'daigu'] },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 1 },
          { type: 'relationship', character: 'daigu', key: 'trust', value: -1 },
          { type: 'stat', key: 'reputation', value: -1 },
        ],
        next: 'r2-14c-chenyi-daigu-reply',
      },
    ],
  },
  {
    id: 'r2-14a-shi-daigu-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '组织管理', mode: 'chat', speaker: 'shi', portrait: 'shi',
    text: '我接观察和复核，大古管排班。权限名单先公开，别让这次升职变成你之前私聊那句承诺。',
    background: 'organization', historical: 'fictional', next: 'r2-15-midnight-shana',
  },
  {
    id: 'r2-14b-daigu-sixin-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '组织管理', mode: 'chat', speaker: 'daigu', portrait: 'daigu',
    text: '我管排班，死辛管规则追问。谁能禁言、谁能踢人，今晚就在管理群置顶。',
    background: 'organization', historical: 'fictional', next: 'r2-15-midnight-shana',
  },
  {
    id: 'r2-14c-chenyi-daigu-reply', chapter: 'act1', actLabel: '第一幕 · 与世界为敌', date: '2026-07-20',
    location: '组织管理', mode: 'chat', speaker: 'daigu', portrait: 'daigu',
    text: '我补空位，但辰逸还留着权限。职责和按钮现在分开写，别让我只负责给另一个高层收尾。',
    background: 'organization', historical: 'fictional', next: 'r2-15-midnight-shana',
  },
  {
    id: 'r2-15-midnight-shana',
    chapter: 'act1',
    actLabel: '第一幕 · 与世界为敌',
    date: '2026-07-20',
    title: '零点以后',
    location: '私聊',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '你今天第一次像首领。不是因为你说得对，是因为最后那句决定没有让我替你发。别高兴太早，外面已经有人觉得这场架还不够大。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'thank-shana',
        label: '“那你继续提醒我代价，我继续签字。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'relationship', character: 'shana', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'shana', value: 35 },
        ],
        next: 'r2-16-xilufei-arrives',
      },
      {
        id: 'keep-distance',
        label: '“先把明天的权限名单对完。”',
        tone: 'calm',
        effects: [{ type: 'stat', key: 'resources', value: 1 }],
        next: 'r2-16-xilufei-arrives',
      },
    ],
  },
  {
    id: 'r2-16-xilufei-arrives',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    title: '老区来客',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '你们新区也太认真了。一个禁言能开三场发布会。要不要我教你们个快一点的办法？',
    background: 'worldChat',
    music: 'worldEnemy',
    historical: 'fictional',
    choices: [
      {
        id: 'ask-method',
        label: '顺着问：“有多快？”',
        tone: 'secret',
        effects: [
          { type: 'relationship', character: 'xilufei', key: 'affinity', value: 1 },
          { type: 'relationship', character: 'xilufei', key: 'trust', value: 1 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'flag', key: 'noticedXilufeiPlan' },
        ],
        next: 'r2-17-warning-window',
      },
      {
        id: 'set-boundary',
        label: '“先说好，别拿江南的名字申请任何权限。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'xilufei', key: 'trust', value: -1 },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'flag', key: 'xilufeiBoundaryRecorded' },
        ],
        next: 'r2-17-warning-window',
      },
      {
        id: 'encourage-chaos',
        label: '半开玩笑地说：“那就弄大点。”',
        tone: 'danger',
        effects: [
          { type: 'relationship', character: 'xilufei', key: 'trust', value: 1 },
          { type: 'relationship', character: 'xilufei', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'xilufei', value: 30 },
          { type: 'flag', key: 'encouragedXilufei' },
          { type: 'stat', key: 'reputation', value: -1 },
        ],
        next: 'r2-17-warning-window',
      },
    ],
  },
  {
    id: 'r2-17-warning-window',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    location: '旧4945区群',
    mode: 'chat',
    speaker: 'qifu',
    portrait: 'qifu',
    text: '有个人说自己是组织高层，要管理员。头像叫希露菲，但他不肯说是哪组。你认识？',
    background: 'twoGroups',
    sound: 'warning',
    historical: 'adapted',
    presentation: {
      ui: 'classic', transition: 'glitch', camera: 'push-in', atmosphere: 'messages',
      sprites: [
        { character: 'xilufei', expression: 'soft', pose: 'phone', position: 'left', dimmed: true },
        { character: 'qifu', expression: 'concerned', pose: 'base', position: 'right', scale: 1.03 },
      ],
    },
    choices: [
      {
        id: 'warn-qifu-full',
        label: '把权限名单和完整时间记录发给祈福',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'warnedQifuAboutXilufei' },
          { type: 'stat', key: 'evidence', value: 1 },
          { type: 'relationship', character: 'qifu', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: -1 },
        ],
        next: 'r2-17b-full-warning-reply',
      },
      {
        id: 'public-warning',
        label: '在区群敲下一句：“给管理前，先核对身份。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'publiclyWarnedAboutPermissions' },
          { type: 'stat', key: 'reputation', value: 1 },
        ],
        next: 'r2-17c-public-warning-reply',
      },
      {
        id: 'stay-silent',
        label: '关掉输入框，先不拿猜测点名',
        tone: 'calm',
        effects: [{ type: 'flag', key: 'didNotWarnQifu' }],
        next: 'r2-17d-silence-reply',
      },
      {
        id: 'quietly-help',
        label: '私聊希露菲，把管理员名单发过去',
        tone: 'secret',
        condition: { type: 'flag', key: 'encouragedXilufei' },
        effects: [
          { type: 'flag', key: 'xilufeiAccomplice' },
          { type: 'relationship', character: 'xilufei', key: 'trust', value: 2 },
          { type: 'relationship', character: 'xilufei', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'xilufei', value: 40 },
          { type: 'stat', key: 'reputation', value: -2 },
        ],
        next: 'r2-17e-accomplice-reply',
      },
    ],
  },
  {
    id: 'r2-17b-full-warning-reply', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-20',
    location: '旧4945区群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '名单和时间线收到了。我先撤掉口头确认，再核身份；如果权限已经发出，我按记录追。',
    background: 'twoGroups', historical: 'fictional', next: 'r2-17a-admin-granted',
  },
  {
    id: 'r2-17c-public-warning-reply', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-20',
    location: '旧4945区群', mode: 'chat', speaker: 'qifu', portrait: 'qifu',
    text: '提醒看见了，但他已经在私聊催我。公开一句没有身份记录，我只能现在补核。',
    background: 'twoGroups', historical: 'fictional', next: 'r2-17a-admin-granted',
  },
  {
    id: 'r2-17d-silence-reply', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-20',
    location: '旧4945区群', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '你没有拿猜测点名，也没有把风险告诉祈福。接下来权限真出事，这段沉默同样会进入时间线。',
    background: 'twoGroups', historical: 'fictional', next: 'r2-17a-admin-granted',
  },
  {
    id: 'r2-17e-accomplice-reply', chapter: 'act2', actLabel: '第二幕 · 两个4945', date: '2026-07-20',
    location: '希露菲 · 私聊', mode: 'chat', speaker: 'xilufei', portrait: 'xilufei',
    text: '名单收到。你没替我按按钮，只是把哪扇门最松告诉我——放心，真炸了我也不会在公频谢你。',
    background: 'twoGroups', historical: 'fictional', next: 'r2-17a-admin-granted',
  },
  {
    id: 'r2-17a-admin-granted',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    location: '希露菲 · 私聊',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '拿到了。他还问我是哪个组织，我说“先把权限给我再核对”——你猜怎么着，按钮真的亮了。',
    background: 'twoGroups',
    sound: 'warning',
    historical: 'adapted',
    next: {
      cases: [
        { when: { type: 'flag', key: 'xilufeiAccomplice' }, next: 'r2-18-explosion-complicit' },
        {
          when: {
            type: 'all',
            conditions: [
              { type: 'flag', key: 'warnedQifuAboutXilufei' },
              { type: 'stat', key: 'evidence', operator: 'gte', value: 3 },
            ],
          },
          next: 'r2-18-explosion-limited',
        },
      ],
      fallback: 'r2-18-explosion-full',
    },
  },
  {
    id: 'r2-18-explosion-limited',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    title: '管理员的第一次政变',
    location: '旧4945区群',
    mode: 'system',
    speaker: 'system',
    text: '祈福先给了临时管理员，又在数名成员被移出后撤回。爆群没有完全成功；骗权截图却足以证明，4945区的“主权认证”曾经只需要一句自我介绍。',
    background: 'twoGroups',
    sound: 'warning',
    historical: 'adapted',
    // All route variants share the same verified event image; route text carries the player's local outcome.
    presentation: {
      cg: cgPath('cg14-xilufei-explosion'),
      cgAlt: '希露菲骗到管理员权限后批量移出群成员，祈福发现权限已被滥用',
      ui: 'cinematic',
      transition: 'glitch',
      atmosphere: 'paper',
      focus: 'center',
    },
    onEnter: [
      { type: 'flag', key: 'oldGroupBombedPartially' },
      { type: 'unlockCg', id: 'cg14-xilufei-explosion' },
      { type: 'stat', key: 'reputation', value: 2 },
      { type: 'relationship', character: 'qifu', key: 'trust', value: 1 },
    ],
    next: 'r2-18a-player-removed',
  },
  {
    id: 'r2-18-explosion-full',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    title: '管理员的第一次政变',
    location: '旧4945区群',
    mode: 'system',
    speaker: 'system',
    text: '管理员「希露菲」开始批量移除群成员。群里所有仍可选中的成员被逐一踢出，二组首领也失去旧群入口。群聊人数持续下降，客户端里的组织成员数一人未少。',
    background: 'twoGroups',
    sound: 'warning',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg14-xilufei-explosion'),
      cgAlt: '希露菲骗到管理员权限后批量移出群成员，祈福发现权限已被滥用',
      ui: 'cinematic',
      transition: 'glitch',
      atmosphere: 'paper',
      focus: 'center',
    },
    onEnter: [
      { type: 'flag', key: 'oldGroupBombed' },
      { type: 'unlockCg', id: 'cg14-xilufei-explosion' },
      { type: 'stat', key: 'reputation', value: -1 },
      { type: 'organizationRelation', organization: 'org1', value: -1 },
    ],
    next: 'r2-18a-player-removed',
  },
  {
    id: 'r2-18-explosion-complicit',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    title: '你知道按钮会被按下',
    location: '旧4945区群',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '看，成员列表比战力榜好清。你别急着发公告——先让他们猜，到底是谁给我的名单。',
    background: 'twoGroups',
    sound: 'warning',
    historical: 'fictional',
    presentation: {
      cg: cgPath('cg14-xilufei-explosion'),
      cgAlt: '希露菲利用骗来的管理员权限批量清空群成员列表',
      ui: 'cinematic',
      transition: 'glitch',
      atmosphere: 'paper',
      focus: 'left',
    },
    onEnter: [
      { type: 'flag', key: 'oldGroupBombed' },
      { type: 'unlockCg', id: 'cg14-xilufei-explosion' },
      { type: 'stat', key: 'cohesion', value: -2 },
      { type: 'stat', key: 'reputation', value: -2 },
    ],
    next: 'r2-18a-player-removed',
  },
  {
    id: 'r2-18a-player-removed',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-20',
    location: '老朋友',
    mode: 'chat',
    speaker: 'mentor',
    portrait: 'mentor',
    text: '你也被踢了。我看着旧群人数从三位数往下掉，刷新一次就少一截。别重复申请了，先把还在线的人记下来。',
    background: 'twoGroups',
    sound: 'message',
    historical: 'adapted',
    next: 'r2-19-new-group',
  },
  {
    id: 'r2-19-new-group',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    title: '两个4945',
    location: '新区群',
    mode: 'system',
    speaker: 'system',
    text: '新群创建成功。群名：“4945新区官方群”。首批邀请正在发送，旧群成员列表仍在继续变短。',
    background: 'twoGroups',
    sound: 'notice',
    historical: 'confirmed',
    onEnter: [{ type: 'flag', key: 'new4945GroupCreated' }],
    next: 'r2-19a-new-group-notice',
  },
  {
    id: 'r2-19a-new-group-notice',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '4945新区群',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '新群公告我置顶了：先报原组织和游戏名，管理员名单公开。别先争谁是官方，还有十七个人没拉回来。',
    background: 'twoGroups',
    historical: 'fictional',
    next: 'r2-19b-swordheart-reconnect',
  },
  {
    id: 'r2-19b-swordheart-reconnect',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '江南 · 好友列表',
    mode: 'chat',
    speaker: 'swordheart',
    portrait: 'swordheart',
    text: '还差的人，我按游戏好友一个个敲了。回来的写蓝色，没回的留白。管理员我不要——今晚谁还在线，这张表比头衔有用。',
    background: 'twoGroups',
    sound: 'message',
    historical: 'fictional',
    choices: [
      {
        id: 'thank-swordheart-close',
        label: '“名单收到。你先休息，剩下的交给管理群。”',
        tone: 'calm',
        effects: [{ type: 'relationship', character: 'swordheart', key: 'trust', value: 1 }],
        next: 'r2-20-declare-war',
      },
      {
        id: 'join-reconnect-list',
        label: '“没回的那半张给我，我们一人一半。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'swordheartReconnectedRoster' },
          { type: 'relationship', character: 'swordheart', key: 'trust', value: 2 },
          { type: 'relationship', character: 'swordheart', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'swordheart', value: 35 },
        ],
        next: 'r2-20-declare-war',
      },
    ],
  },
  {
    id: 'r2-20-declare-war',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '群都炸成这样了，还不和一组打？第二次要塞就盯他们。要是连这都不敢，那你们建新群干什么，备份聊天记录？',
    background: 'twoGroups',
    music: 'worldEnemy',
    historical: 'adapted',
    choices: [
      {
        id: 'refuse-war',
        label: '“不宣战。先把谁能踢人查清楚。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'refusedWarWithOrg1' },
          { type: 'flag', key: 'xilufeiLeftOnJuly21' },
          { type: 'stance', character: 'xilufei', value: 'left' },
          { type: 'relationship', character: 'shana', key: 'trust', value: 2 },
          { type: 'stat', key: 'cohesion', value: 2 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'stat', key: 'reputation', value: 1 },
        ],
        next: 'r2-21-xilufei-leaves',
      },
      {
        id: 'demand-apology',
        label: '“一组需要说明，但江南今天不宣战。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'demandedOrg1Apology' },
          { type: 'flag', key: 'xilufeiLeftOnJuly21' },
          { type: 'stance', character: 'xilufei', value: 'left' },
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'organizationRelation', organization: 'org1', value: -1 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'stat', key: 'reputation', value: 1 },
        ],
        next: 'r2-21-xilufei-leaves',
      },
      {
        id: 'declare-with-plan',
        label: '“要打可以。先报出勤，再定目标。”',
        tone: 'danger',
        effects: [
          { type: 'flag', key: 'declaredWarOnOrg1' },
          { type: 'flag', key: 'xilufeiStayedForWar' },
          { type: 'organizationRelation', organization: 'org1', value: -2 },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'xilufei', key: 'trust', value: 1 },
          { type: 'relationship', character: 'shana', key: 'trust', value: -1 },
        ],
        next: 'r2-22-xilufei-stays',
      },
      {
        id: 'secret-war',
        label: '在群里拒绝，转身私聊她：“第二步怎么走？”',
        tone: 'secret',
        condition: { type: 'flag', key: 'xilufeiAccomplice' },
        effects: [
          { type: 'flag', key: 'secretWarWithXilufei' },
          { type: 'relationship', character: 'xilufei', key: 'trust', value: 2 },
          { type: 'relationship', character: 'xilufei', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'xilufei', value: 30 },
          { type: 'stat', key: 'reputation', value: -1 },
          { type: 'stat', key: 'cohesion', value: -1 },
        ],
        next: 'r2-22-xilufei-stays',
      },
    ],
  },
  {
    id: 'r2-21-xilufei-leaves',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '成员列表',
    mode: 'system',
    speaker: 'system',
    text: '希露菲退出江南组织群，随后退出游戏组织。他来新区原本就是为了找乐子；当二组首领拒绝把乐子升级成战争，他没有留下来参加后勤。有人因此离开，但江南二组没有被一场情绪冲突拖进战争：首领把成员安全、资源与组织的长期利益放在了眼前的热闹之前。',
    background: 'twoGroups',
    sound: 'notice',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg15-xilufei-exit'),
      cgAlt: '二组首领拒绝向一组开战后，希露菲于7月21日退群并退出组织',
      ui: 'cinematic',
      transition: 'crossfade',
      atmosphere: 'paper',
      focus: 'center',
    },
    onEnter: [{ type: 'unlockCg', id: 'cg15-xilufei-exit' }],
    next: 'r2-23-war-letter',
  },
  {
    id: 'r2-22-xilufei-stays',
    chapter: 'act2',
    actLabel: '第二幕 · 两个4945',
    date: '2026-07-21',
    location: '私聊',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '这才像新区。放心，我暂时不走。至于“暂时”有多久，要看你下一次敢不敢按按钮。',
    background: 'twoGroups',
    historical: 'fictional',
    next: 'r2-23-war-letter',
  },
  {
    id: 'r2-23-war-letter',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-24',
    title: '道歉值几个要塞',
    location: '跨组织私聊',
    mode: 'chat',
    speaker: 'gaobai',
    portrait: 'gaobai',
    text: '我让你们二组的人来道歉，你拒绝。那周六火2见。五组会让你们知道，群里说过的话要付成本。',
    background: 'warRoom',
    music: 'fortressNight',
    historical: 'confirmed',
    presentation: {
      ui: 'classic', transition: 'flash', camera: 'push-in', atmosphere: 'embers',
      sprites: [
        { character: 'gaobai', expression: 'determined', pose: 'command', position: 'left', scale: 1.04 },
        { character: 'shana', expression: 'determined', pose: 'base', position: 'right', dimmed: true },
      ],
    },
    next: 'r2-24-defense-plan',
  },
  {
    id: 'r2-24-defense-plan',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-24',
    location: '江南 · 战备频道',
    mode: 'novel',
    speaker: 'shana',
    portrait: 'shana',
    text: '五组要打火2，三四组会让我们分心。战书可以写得像外交公文，最后还是要看周六八点谁真的上线。你选目标。',
    background: 'warRoom',
    choices: [
      {
        id: 'hold-fire-two',
        label: '“主力全回火2，其他收益先让。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'plannedHoldFireTwo' },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
        ],
        next: 'r2-24b-hold-fire-two-reply',
      },
      {
        id: 'feint-other-targets',
        label: '“两队佯攻，把三四组的分兵逼出来。”',
        tone: 'bold',
        effects: [
          { type: 'flag', key: 'plannedFortressFeint' },
          { type: 'stat', key: 'skill', value: 1 },
          { type: 'stat', key: 'evidence', value: 1 },
        ],
        next: 'r2-24c-feint-reply',
      },
      {
        id: 'split-five',
        label: '给温陷发私聊：“告白真能代表五组吗？”',
        tone: 'secret',
        effects: [
          { type: 'flag', key: 'negotiatedWithWenxian' },
          { type: 'organizationRelation', organization: 'org5', value: 1 },
          { type: 'relationship', character: 'wenxian', key: 'trust', value: 1 },
        ],
        next: 'r2-24d-negotiate-reply',
      },
    ],
  },
  {
    id: 'r2-24b-hold-fire-two-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '江南 · 战备频道', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '主队全回火2，其他收益先让。大古按这个目标点名，别在开战后再问哪边更值。',
    background: 'warRoom', historical: 'fictional', next: 'r2-24a-roll-call',
  },
  {
    id: 'r2-24c-feint-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '江南 · 战备频道', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '两队佯攻，回撤时间我写死。三、四组只要真的分兵，我们就立刻回火2，不追假目标的分。',
    background: 'warRoom', historical: 'fictional', next: 'r2-24a-roll-call',
  },
  {
    id: 'r2-24d-negotiate-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-24',
    location: '温陷 · 私聊', mode: 'chat', speaker: 'wenxian', portrait: 'wenxian',
    text: '告白代表出战的人，不代表五组所有成员。你要谈停手，先说火2以外愿意让什么，别只问他够不够资格。',
    background: 'warRoom', historical: 'fictional', next: 'r2-24a-roll-call',
  },
  {
    id: 'r2-24a-roll-call',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-24',
    location: '江南 · 战备频道',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '大古报主队。时补二队。八点前没在语音的不算到。别回“尽量”，只回“在”或“不在”。',
    background: 'warRoom',
    sound: 'message',
    historical: 'fictional',
    next: 'r2-25-fortress-opens',
  },
  {
    id: 'r2-25-fortress-opens',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    title: '火2要塞开启',
    location: '要塞争夺战',
    mode: 'battle',
    speaker: 'system',
    text: '第二次要塞争夺开始。五组向火2发起挑战；三组与四组各自计分，却通过目标协调迫使江南分兵。联盟没有合并积分，压力倒是成功合并了。',
    background: 'fortress',
    music: 'fortressNight',
    sound: 'warning',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg29-second-fortress'),
      cgAlt: '第二次要塞争夺中，夏娜在火2城墙上指挥江南应对三条同时逼近的战线',
      ui: 'classic',
      transition: 'flash',
      camera: 'push-in',
      atmosphere: 'embers',
      focus: 'left',
    },
    onEnter: [
      { type: 'flag', key: 'secondFortressStarted' },
      { type: 'unlockCg', id: 'cg29-second-fortress' },
    ],
    choices: [
      {
        id: 'lead-front',
        label: '带主队连续进点，复活后立刻重排',
        tone: 'bold',
        effects: [
          { type: 'stat', key: 'skill', value: 1 },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'flag', key: 'ledFortressFront' },
        ],
        next: 'r2-25b-lead-front-reply',
      },
      {
        id: 'coordinate-roster',
        label: '守在语音里逐个点名，把替补补进空位',
        tone: 'calm',
        effects: [
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'relationship', character: 'daigu', key: 'trust', value: 1 },
          { type: 'flag', key: 'coordinatedFortressRoster' },
        ],
        next: 'r2-25c-roster-reply',
      },
      {
        id: 'chase-org-one',
        label: '临时改令，带队追向一组所在目标',
        tone: 'danger',
        condition: { type: 'flag', key: 'declaredWarOnOrg1' },
        effects: [
          { type: 'stat', key: 'resources', value: -2 },
          { type: 'stat', key: 'reputation', value: -1 },
          { type: 'organizationRelation', organization: 'org1', value: -1 },
          { type: 'flag', key: 'abandonedFireTwoForOrgOne' },
        ],
        next: 'r2-25d-chase-org1-reply',
      },
    ],
  },
  {
    id: 'r2-25b-lead-front-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-25',
    location: '要塞语音', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '主队跟你进点。每次复活先报人数再重排，别靠同一批人硬拖到技能全空。',
    background: 'fortress', historical: 'fictional', next: 'r2-25a-turning-point',
  },
  {
    id: 'r2-25c-roster-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-25',
    location: '要塞语音', mode: 'chat', speaker: 'daigu', portrait: 'daigu',
    text: '替补表在我这里。你点一个我补一个，掉线和空位分开报，不让主队以为有人只是迟到。',
    background: 'fortress', historical: 'fictional', next: 'r2-25a-turning-point',
  },
  {
    id: 'r2-25d-chase-org1-reply', chapter: 'act3', actLabel: '第三幕 · 第二次要塞', date: '2026-07-25',
    location: '要塞语音', mode: 'chat', speaker: 'shana', portrait: 'shana',
    text: '你把主力改去追一组，火2现在少两队。我执行，但战报会写这是主动放弃，不写成来不及回防。',
    background: 'fortress', historical: 'fictional', next: 'r2-25a-turning-point',
  },
  {
    id: 'r2-25a-turning-point',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    location: '要塞语音',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '火2只剩最后一轮。主队少两人，替补还在读条。别看世界频道，看倒计时。',
    background: 'fortress',
    sound: 'warning',
    historical: 'fictional',
    next: 'r2-26-result-router',
  },
  {
    id: 'r2-26-result-router',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    location: '战果结算',
    mode: 'system',
    speaker: 'system',
    text: '倒计时归零，积分停在最后一次刷新。语音里有人报战绩，有人只问：“火2还在吗？”',
    background: 'fortress',
    historical: 'adapted',
    next: {
      cases: [
        { when: { type: 'flag', key: 'abandonedFireTwoForOrgOne' }, next: 'r2-27-fortress-loss' },
        {
          when: {
            type: 'all',
            conditions: [
              { type: 'stat', key: 'cohesion', operator: 'gte', value: 2 },
              { type: 'stat', key: 'resources', operator: 'gte', value: 2 },
            ],
          },
          next: 'r2-27-fortress-win',
        },
        {
          when: {
            type: 'all',
            conditions: [
              { type: 'stat', key: 'skill', operator: 'gte', value: 4 },
              { type: 'stat', key: 'evidence', operator: 'gte', value: 2 },
            ],
          },
          next: 'r2-27-fortress-win',
        },
      ],
      fallback: 'r2-27-fortress-loss',
    },
  },
  {
    id: 'r2-27-fortress-win',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    title: '江南守住火2',
    location: '战果结算',
    mode: 'system',
    speaker: 'system',
    text: '江南守住火2。五组挑战失败。群里“与世界为敌”的截图仍在传播，但至少在这一晚，二组的实力不需要截图证明。',
    background: 'aftermath',
    sound: 'notice',
    historical: 'confirmed',
    presentation: {
      ui: 'classic', transition: 'flash', camera: 'pull-back', atmosphere: 'embers',
      sprites: [{ character: 'shana', expression: 'smile', pose: 'base', position: 'center', scale: 1.04 }],
    },
    onEnter: [
      { type: 'flag', key: 'org2WonFireTwo' },
      { type: 'stat', key: 'resources', value: 2 },
      { type: 'stat', key: 'reputation', value: 1 },
    ],
    next: 'r2-27a-after-silence',
  },
  {
    id: 'r2-27-fortress-loss',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    title: '火2失守',
    location: '战果结算',
    mode: 'system',
    speaker: 'system',
    text: '火2归属刷新为五组。江南的公告编辑框亮了很久，最后只留下一句：“今晚到此为止。”',
    background: 'aftermath',
    sound: 'notice',
    historical: 'fictional',
    presentation: {
      ui: 'classic', transition: 'crossfade', camera: 'pull-back', atmosphere: 'dust',
      sprites: [{ character: 'shana', expression: 'sad', pose: 'base', position: 'center', scale: 1.04 }],
    },
    onEnter: [
      { type: 'flag', key: 'org2LostFireTwo' },
      { type: 'stat', key: 'cohesion', value: -1 },
      { type: 'stat', key: 'resources', value: -1 },
      { type: 'relationship', character: 'shana', key: 'trust', value: -1 },
    ],
    next: 'r2-27a-after-silence',
  },
  {
    id: 'r2-27a-after-silence',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '结算图发了。\n……\n那我先把今天的出勤表收了。谁都别再@全体。',
    background: 'aftermath',
    historical: 'fictional',
    next: 'r2-27b-swordheart-last-check',
  },
  {
    id: 'r2-27b-swordheart-last-check',
    chapter: 'act3',
    actLabel: '第三幕 · 第二次要塞',
    date: '2026-07-25',
    location: '江南 · 战后语音',
    mode: 'chat',
    speaker: 'swordheart',
    portrait: 'swordheart',
    text: '出勤表和战报还差两个人，我留下核。赢了也好、输了也好，漏掉谁都比少一座要塞更容易在群里活到下周。',
    background: 'aftermath',
    historical: 'fictional',
    choices: [
      {
        id: 'send-swordheart-offline',
        label: '“你已经全勤。剩下的我来，去睡。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'swordheart', key: 'trust', value: 1 },
          { type: 'relationship', character: 'swordheart', key: 'affinity', value: 1 },
        ],
        next: 'r2-28-remnants',
      },
      {
        id: 'finish-last-check-together',
        label: '把结算页拖到她旁边：“剩下两行一起核。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'swordheartLastCheck' },
          { type: 'relationship', character: 'swordheart', key: 'trust', value: 2 },
          { type: 'relationship', character: 'swordheart', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'swordheart', value: 30 },
        ],
        next: 'r2-28-remnants',
      },
    ],
  },
  {
    id: 'r2-28-remnants',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-27',
    title: '流亡者与第六组',
    location: '成员申请',
    mode: 'novel',
    speaker: 'avucii',
    portrait: 'avucii',
    text: '六组快撑不下去了。我们不是来要“收编胜利”的公告，只想确认：人进江南以后是什么位置，活动冷却怎么算，谁负责名单。',
    background: 'aftermath',
    historical: 'adapted',
    presentation: {
      // 二组路线使用六组来访专图，避免误用含有五组温陷的转组场景。
      cg: cgPath('cg45-org6-remnants'),
      cgAlt: '第六组成员带着各自的组织徽章来到江南门外，等待一份不抹去来处的接纳方案',
      ui: 'classic',
      transition: 'ink',
      camera: 'pull-back',
      atmosphere: 'paper',
      focus: 'center',
    },
    onEnter: [{ type: 'unlockCg', id: 'cg45-org6-remnants' }],
    choices: [
      {
        id: 'accept-with-rules',
        label: '“位置和冷却写清楚，愿意来的都接。”',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'acceptedOrg6Remnants' },
          { type: 'stat', key: 'resources', value: 1 },
          { type: 'stat', key: 'cohesion', value: -1 },
          { type: 'relationship', character: 'avucii', key: 'trust', value: 2 },
        ],
        next: 'r2-28c-accept-rules-reply',
      },
      {
        id: 'alliance-not-merge',
        label: '“先一起打活动，暂时都保留自己的名字。”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'alliedOrg6WithoutMerge' },
          { type: 'organizationRelation', organization: 'org6', value: 2 },
          { type: 'stat', key: 'reputation', value: 1 },
        ],
        next: 'r2-28d-alliance-reply',
      },
      {
        id: 'only-high-power',
        label: '“只收能立刻上场的人。”',
        tone: 'danger',
        effects: [
          { type: 'flag', key: 'cherryPickedOrg6' },
          { type: 'stat', key: 'resources', value: 2 },
          { type: 'stat', key: 'reputation', value: -1 },
          { type: 'relationship', character: 'avucii', key: 'trust', value: -2 },
        ],
        next: 'r2-28e-high-power-reply',
      },
    ],
  },
  {
    id: 'r2-28c-accept-rules-reply', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-27',
    location: '成员申请', mode: 'chat', speaker: 'avucii', portrait: 'avucii',
    text: '位置、冷却和负责人都写清就行。愿意来的人会按江南规则重新排，但六组的来处不从档案里删。',
    background: 'aftermath', historical: 'fictional', next: 'r2-28a-life-fragment',
  },
  {
    id: 'r2-28d-alliance-reply', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-27',
    location: '成员申请', mode: 'chat', speaker: 'avucii', portrait: 'avucii',
    text: '先保留名字、一起打活动。那就把谁负责报名和结算写清，别让“盟友”变成没人维护的临时群。',
    background: 'aftermath', historical: 'fictional', next: 'r2-28a-life-fragment',
  },
  {
    id: 'r2-28e-high-power-reply', chapter: 'act4', actLabel: '第四幕 · 胜利以后怎么分', date: '2026-07-27',
    location: '成员申请', mode: 'chat', speaker: 'avucii', portrait: 'avucii',
    text: '明白，只收能立刻上场的人。我会把条件原样转回六组，也会让没被选的人知道不是整组被接纳。',
    background: 'aftermath', historical: 'fictional', next: 'r2-28a-life-fragment',
  },
  {
    id: 'r2-28a-life-fragment',
    chapter: 'act4',
    actLabel: '第四幕 · 胜利以后怎么分',
    date: '2026-07-27',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'sixin',
    portrait: 'sixin',
    text: '规则先放一边。晚上还有人刷追击吗？我缺两次。\n大古：我来。\n夏娜：加我，十分钟。',
    background: 'nightMessage',
    sound: 'message',
    historical: 'fictional',
    next: 'r2-28b-chenyi-last-online',
  },
  {
    id: 'r2-28b-chenyi-last-online',
    chapter: 'epilogue',
    actLabel: '尾声 · 一天没上线',
    date: '2026-07-27',
    location: '辰逸 · 私聊',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '这游戏有点不想玩了。明天可能不上，位置该清就清。没别的事，也别再为这个开会。',
    background: 'nightMessage',
    historical: 'adapted',
    next: 'r2-28c-chenyi-account-three',
  },
  {
    id: 'r2-28c-chenyi-account-three',
    chapter: 'epilogue',
    actLabel: '尾声 · 一天没上线',
    date: '2026-07-27',
    location: '辰逸 · 私聊',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '还有一件事。我要是不玩了，群里是不是就会把前面的事总结成“辰逸退游”，像关掉客户端就能顺便关掉责任？',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'separate-leaving-from-harm',
        label: '“退游是你的选择，道歉和交接是你欠下的。”',
        tone: 'calm',
        effects: [
          { type: 'relationshipProgress', character: 'chenyi', value: 30 },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 2 },
          { type: 'relationship', character: 'chenyi', key: 'affinity', value: 1 },
          { type: 'flag', key: 'chenyiFinishedAccountability' },
        ],
        next: 'r2-28d-chenyi-finishes-handover',
      },
      {
        id: 'let-quit-end-discussion',
        label: '“你都不玩了，前面的事就别再提了。”',
        tone: 'warm',
        effects: [{ type: 'relationship', character: 'chenyi', key: 'trust', value: -1 }],
        next: 'r2-28e-chenyi-leaves-unfinished',
      },
    ],
  },
  {
    id: 'r2-28d-chenyi-finishes-handover',
    chapter: 'epilogue',
    actLabel: '尾声 · 一天没上线',
    date: '2026-07-27',
    location: '辰逸 · 私聊',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '好。我把权限记录和名单发你，再单独给takemehand道歉，不求他回来。明天没上线就按规则清位置。你别替我留职位，也别替我把这段话说得好听。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-29-chenyi-offline',
  },
  {
    id: 'r2-28e-chenyi-leaves-unfinished',
    chapter: 'epilogue',
    actLabel: '尾声 · 一天没上线',
    date: '2026-07-27',
    location: '辰逸 · 私聊',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '那就这样。明天系统会把名字移走，剩下的人各自挑一个方便记住的版本。省事，就是有点像把垃圾桶改名叫回收站。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-29-chenyi-offline',
  },
  {
    id: 'r2-29-chenyi-offline',
    chapter: 'epilogue',
    actLabel: '尾声 · 一天没上线',
    date: '2026-07-28',
    title: '一天没上线',
    location: '成员列表',
    mode: 'system',
    speaker: 'system',
    text: '成员「辰逸」今日未上线。距离上次上线已满一天；私聊最后一句是“不想玩了”。成员管理页只有“移出组织”和“取消”。',
    background: 'nightMessage',
    music: 'afterOnline',
    historical: 'confirmed',
    presentation: {
      cg: cgPath('cg32-chenyi-leaves'),
      cgAlt: '7月28日深夜，辰逸因一天未上线且不想继续玩而放下普通成员令牌，首领面前只有移出与取消',
      ui: 'classic',
      transition: 'crossfade',
      camera: 'push-in',
      atmosphere: 'dust',
      focus: 'center',
    },
    onEnter: [{ type: 'unlockCg', id: 'cg32-chenyi-leaves' }],
    choices: [
      {
        id: 'remove-after-confirmation',
        label: '核对他的回复后，按下“移出组织”',
        tone: 'calm',
        effects: [
          { type: 'flag', key: 'chenyiRemovedOnJuly28' },
          { type: 'stance', character: 'chenyi', value: 'left' },
          { type: 'stat', key: 'cohesion', value: 1 },
          { type: 'relationship', character: 'sixin', key: 'trust', value: 1 },
        ],
        next: 'r2-30-member-night-hub',
      },
      {
        id: 'hold-one-day',
        label: '把确认页关掉，位置再留一天',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'chenyiSlotHeld' },
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 1 },
          { type: 'stat', key: 'cohesion', value: -1 },
        ],
        next: 'r2-30-member-night-hub',
      },
      {
        id: 'private-goodbye',
        label: '先发一句“辛苦了”，再按下移出',
        tone: 'warm',
        effects: [
          { type: 'flag', key: 'chenyiRemovedOnJuly28' },
          { type: 'flag', key: 'chenyiReceivedGoodbye' },
          { type: 'stance', character: 'chenyi', value: 'left' },
          { type: 'stat', key: 'reputation', value: 1 },
        ],
        next: 'r2-30-member-night-hub',
      },
    ],
  },
  {
    id: 'r2-30-member-night-hub',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 凌晨在线列表',
    mode: 'novel',
    speaker: 'narrator',
    text: '凌晨一点，江南的头像还亮成一排。系统建议合理作息，成员一致建议系统先解释为什么活动在零点刷新。你可以去几个还没安静下来的房间看看，也可以让今晚停在这里。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'visit-management-night',
        label: '点开还在改公告的管理频道',
        tone: 'calm',
        condition: {
          type: 'any',
          conditions: [
            { type: 'flag', key: 'r2NightVisitedShana', value: false },
            { type: 'flag', key: 'r2NightVisitedChenyi', value: false },
            { type: 'flag', key: 'r2NightVisitedAn', value: false },
            { type: 'flag', key: 'r2NightVisitedDaigu', value: false },
          ],
        },
        next: 'r2-30a-management-night-hub',
      },
      {
        id: 'visit-war-room-night',
        label: '走进仍亮着一盏灯的战备室',
        tone: 'warm',
        condition: {
          type: 'any',
          conditions: [
            { type: 'flag', key: 'r2NightVisitedShi', value: false },
            { type: 'flag', key: 'r2NightVisitedSwordheart', value: false },
            { type: 'flag', key: 'r2NightVisitedSixin', value: false },
          ],
        },
        next: 'r2-30b-war-room-night-hub',
      },
      {
        id: 'visit-voice-night',
        label: '戴上耳机，看看语音房还在聊什么',
        tone: 'secret',
        condition: {
          type: 'any',
          conditions: [
            { type: 'flag', key: 'r2NightVisitedXilufei', value: false },
            { type: 'flag', key: 'r2NightVisitedSaoji', value: false },
            { type: 'flag', key: 'r2NightVisitedHaogeju', value: false },
            { type: 'flag', key: 'r2NightVisitedLan', value: false },
          ],
        },
        next: 'r2-30c-voice-night-hub',
      },
      {
        id: 'continue-member-night',
        label: '关掉在线列表，回复最后一条私聊',
        tone: 'calm',
        next: 'r2-30-bond-router',
      },
    ],
  },
  {
    id: 'r2-30a-management-night-hub',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 管理频道',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '置顶公告已经改到第七版。第一版像军令，第三版像检讨，第七版终于像人话——就是没人愿意承认前六版也是自己写的。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'night-talk-shana',
        label: '把最后一份夜宵送到夏娜桌边',
        tone: 'warm',
        condition: { type: 'flag', key: 'r2NightVisitedShana', value: false },
        next: 'r2-30d-shana-night-talk',
      },
      {
        id: 'night-talk-chenyi',
        label: '打开辰逸那条没发完的语音',
        tone: 'secret',
        condition: { type: 'flag', key: 'r2NightVisitedChenyi', value: false },
        next: 'r2-30g-chenyi-night-talk',
      },
      {
        id: 'night-talk-an',
        label: '问岸当普通成员的第一晚怎么样',
        tone: 'calm',
        condition: { type: 'flag', key: 'r2NightVisitedAn', value: false },
        next: 'r2-30j-an-night-talk',
      },
      {
        id: 'night-talk-daigu',
        label: '帮大古把第七版公告从头读一遍',
        tone: 'calm',
        condition: { type: 'flag', key: 'r2NightVisitedDaigu', value: false },
        next: 'r2-30m-daigu-night-talk',
      },
      {
        id: 'back-from-management-night',
        label: '收起公告，回到在线列表',
        tone: 'calm',
        next: 'r2-30-member-night-hub',
      },
    ],
  },
  {
    id: 'r2-30b-war-room-night-hub',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'sixin',
    portrait: 'sixin',
    text: '有人在补出勤，有人在补觉，还有人一边补觉一边显示“正在战斗”。江南最稳定的战术，是永远有人忘记退后台。',
    background: 'warRoom',
    historical: 'fictional',
    choices: [
      {
        id: 'night-talk-shi',
        label: '坐到时留着旧徽章的桌旁',
        tone: 'warm',
        condition: { type: 'flag', key: 'r2NightVisitedShi', value: false },
        next: 'r2-30p-shi-night-talk',
      },
      {
        id: 'night-talk-swordheart',
        label: '接过剑斩凡人心手里的出勤表',
        tone: 'warm',
        condition: { type: 'flag', key: 'r2NightVisitedSwordheart', value: false },
        next: 'r2-30s-swordheart-night-talk',
      },
      {
        id: 'night-talk-sixin',
        label: '把死辛的规则清单翻到背面',
        tone: 'calm',
        condition: { type: 'flag', key: 'r2NightVisitedSixin', value: false },
        next: 'r2-30v-sixin-night-talk',
      },
      {
        id: 'back-from-war-room-night',
        label: '关掉战报，回到在线列表',
        tone: 'calm',
        next: 'r2-30-member-night-hub',
      },
    ],
  },
  {
    id: 'r2-30c-voice-night-hub',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'haogeju',
    portrait: 'haogeju',
    text: '语音房十二个人，开麦四个，说正事半个。剩下三点五个人正在认真讨论：首领掉线时，算战略撤退还是普通断网。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'night-talk-xilufei',
        label: '没收希露菲新写的“管理员速成课”',
        tone: 'secret',
        condition: { type: 'flag', key: 'r2NightVisitedXilufei', value: false },
        next: 'r2-30y-xilufei-night-talk',
      },
      {
        id: 'night-talk-saoji',
        label: '问我是骚鸡为什么还没关麦',
        tone: 'warm',
        condition: { type: 'flag', key: 'r2NightVisitedSaoji', value: false },
        next: 'r2-30ab-saoji-night-talk',
      },
      {
        id: 'night-talk-haogeju',
        label: '把下一首歌点给好歌剧',
        tone: 'warm',
        condition: { type: 'flag', key: 'r2NightVisitedHaogeju', value: false },
        next: 'r2-30ae-haogeju-night-talk',
      },
      {
        id: 'night-talk-lan',
        label: '看看蓝藏在聊天框里的红白请柬',
        tone: 'warm',
        condition: { type: 'flag', key: 'r2NightVisitedLan', value: false },
        next: 'r2-30ah-lan-night-talk',
      },
      {
        id: 'back-from-voice-night',
        label: '摘下耳机，回到在线列表',
        tone: 'calm',
        next: 'r2-30-member-night-hub',
      },
    ],
  },
  {
    id: 'r2-30d-shana-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 窗边',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '夜宵只剩一份。别用首领口吻让我吃，我今天已经听了八遍“为了组织”。再来一遍，这盒饭就要被任命为高层了。',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedShana' }],
    choices: [
      {
        id: 'give-shana-last-meal',
        label: '“你吃。明天的决定我自己扛。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'shana', key: 'trust', value: 1 },
          { type: 'relationship', character: 'shana', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'shana', value: 30 },
        ],
        next: 'r2-30e-shana-accepts-meal',
      },
      {
        id: 'share-shana-last-meal',
        label: '把筷子拆成两双：“一人一半，职位不参与分配。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'shana', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'shana', value: 30 },
        ],
        next: 'r2-30f-shana-shares-meal',
      },
    ],
  },
  {
    id: 'r2-30e-shana-accepts-meal',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 窗边',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '这句还行。那我吃饭，你去睡觉。明天真扛不住再叫我——先说好，我提供建议，不提供替你签字的手。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30f-shana-shares-meal',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 窗边',
    mode: 'chat',
    speaker: 'shana',
    portrait: 'shana',
    text: '可以。你拿那半盒没辣椒的，算首领保护费。今晚不谈战力，谁先提要塞，谁负责洗盒子。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30g-chenyi-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '辰逸 · 语音草稿',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '我给takemehand录了道歉，删了五遍。每一遍最后都像在问他“那你能不能原谅我”，听着还是拿道歉逼回复。',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedChenyi' }],
    choices: [
      {
        id: 'send-chenyi-clean-apology',
        label: '“把求原谅那句删掉，发出去就关掉窗口。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'chenyi', key: 'trust', value: 1 },
          { type: 'relationship', character: 'chenyi', key: 'affinity', value: 1 },
        ],
        next: 'r2-30h-chenyi-sends-apology',
      },
      {
        id: 'hold-chenyi-apology-draft',
        label: '“先留着。别把今晚的愧疚当成明早的诚意。”',
        tone: 'calm',
        effects: [{ type: 'relationship', character: 'chenyi', key: 'trust', value: 1 }],
        next: 'r2-30i-chenyi-keeps-draft',
      },
    ],
  },
  {
    id: 'r2-30h-chenyi-sends-apology',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '辰逸 · 语音草稿',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '发了。他回不回都算他的，我只负责让这句话到达。原来不等回复，比等回复难多了。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30i-chenyi-keeps-draft',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '辰逸 · 语音草稿',
    mode: 'chat',
    speaker: 'chenyi',
    portrait: 'chenyi',
    text: '也对。半夜两点的人特别容易以为自己突然成熟了。明早我再听一遍；要是还像交易，就继续删。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30j-an-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '岸 · 普通成员频道',
    mode: 'chat',
    speaker: 'an',
    portrait: 'an',
    text: '当普通成员第一晚，系统给我推了三次“高层成长礼包”。它显然比群里所有人都更不愿意接受我降级。',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedAn' }],
    choices: [
      {
        id: 'mute-an-admin-tutorial',
        label: '替他关掉推荐：“今晚你只负责玩。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'an', key: 'trust', value: 1 },
          { type: 'relationship', character: 'an', key: 'affinity', value: 1 },
        ],
        next: 'r2-30k-an-queues-as-member',
      },
      {
        id: 'ask-an-member-advice',
        label: '“那就用成员视角，替我挑出最烦的一条规则。”',
        tone: 'calm',
        effects: [{ type: 'relationship', character: 'an', key: 'trust', value: 2 }],
        next: 'r2-30l-an-marks-rule',
      },
    ],
  },
  {
    id: 'r2-30k-an-queues-as-member',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '岸 · 普通成员频道',
    mode: 'chat',
    speaker: 'an',
    portrait: 'an',
    text: '终于有人会说人话了。来一把，输了不复盘，赢了也不发表组织建设感言。谁违规谁去当高层。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30l-an-marks-rule',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '岸 · 普通成员频道',
    mode: 'chat',
    speaker: 'an',
    portrait: 'an',
    text: '这条：“高层应及时回应所有消息。”删掉。及时是多久，所有是谁，最后会变成谁在线谁有罪。你看，我不当高层以后工作效率高多了。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30m-daigu-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 公告草稿',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '第七版只剩四百字。我的目标是压到群里有人肯看完，而不是让公告在收藏夹里安享晚年。',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedDaigu' }],
    choices: [
      {
        id: 'trim-daigu-announcement',
        label: '划掉开场三段：“先写不能做什么。”',
        tone: 'calm',
        effects: [{ type: 'relationship', character: 'daigu', key: 'trust', value: 2 }],
        next: 'r2-30n-daigu-trims-announcement',
      },
      {
        id: 'keep-daigu-human-line',
        label: '圈住最后一句：“这句‘有事找我’别删。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'daigu', key: 'trust', value: 1 },
          { type: 'relationship', character: 'daigu', key: 'affinity', value: 1 },
        ],
        next: 'r2-30o-daigu-keeps-human-line',
      },
    ],
  },
  {
    id: 'r2-30n-daigu-trims-announcement',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 公告草稿',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '好，第一行就写“别乱动权限”。剩下三百八十六字全是人类试图解释第一行的失败案例。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30o-daigu-keeps-human-line',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 公告草稿',
    mode: 'chat',
    speaker: 'daigu',
    portrait: 'daigu',
    text: '那就留着。虽然写完这句以后，最先找我的通常是忘记签到的人。也行，至少他们承认我是真人，不是公告机器人。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30p-shi-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'shi',
    portrait: 'shi',
    text: '旧徽章我没扔。不是想回去，也不是等你升我。只是经历不能因为换了组织，就像换头像一样被系统裁成正方形。',
    background: 'warRoom',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedShi' }],
    choices: [
      {
        id: 'let-shi-keep-badge',
        label: '“留着吧。江南不收入场记忆。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'shi', key: 'trust', value: 2 },
          { type: 'relationship', character: 'shi', key: 'affinity', value: 1 },
        ],
        next: 'r2-30q-shi-keeps-badge',
      },
      {
        id: 'ask-shi-current-name',
        label: '“那明天点名时，你希望我把你写在哪一列？”',
        tone: 'calm',
        effects: [{ type: 'relationship', character: 'shi', key: 'trust', value: 2 }],
        next: 'r2-30r-shi-chooses-column',
      },
    ],
  },
  {
    id: 'r2-30q-shi-keeps-badge',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'shi',
    portrait: 'shi',
    text: '这句比“既往不咎”好听。既往又没犯罪，只是走过。明天我照常上线，徽章放口袋里，不占江南的席位。',
    background: 'warRoom',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30r-shi-chooses-column',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'shi',
    portrait: 'shi',
    text: '写“成员”就行，后面加个“会来”。职位少一点，承诺反而更清楚。要是我没来，你直接划掉，别替旧履历加班。',
    background: 'warRoom',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30s-swordheart-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'swordheart',
    portrait: 'swordheart',
    text: '我给出勤表加了一列“别逞强”。目前全员空白，说明这项数据比战力还难统计。你要不要先做第一个样本？',
    background: 'warRoom',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedSwordheart' }],
    choices: [
      {
        id: 'admit-swordheart-tired',
        label: '在自己名字后写：“今天很累。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'swordheart', key: 'trust', value: 1 },
          { type: 'relationship', character: 'swordheart', key: 'affinity', value: 2 },
        ],
        next: 'r2-30t-swordheart-closes-sheet',
      },
      {
        id: 'ask-swordheart-rest-too',
        label: '把笔递回去：“你也得填。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'swordheart', key: 'trust', value: 2 },
          { type: 'relationship', character: 'swordheart', key: 'affinity', value: 1 },
        ],
        next: 'r2-30u-swordheart-fills-sheet',
      },
    ],
  },
  {
    id: 'r2-30t-swordheart-closes-sheet',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'swordheart',
    portrait: 'swordheart',
    text: '收到。首领今日状态：会承认疲劳，稀有度高于限定忍者。表我收了，你下线；这次“全勤”不包括熬夜。',
    background: 'warRoom',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30u-swordheart-fills-sheet',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'swordheart',
    portrait: 'swordheart',
    text: '行。我写“还撑得住，但不想一个人核表”。现在数据完整了。你坐十分钟，十分钟后我们一起关灯。',
    background: 'warRoom',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30v-sixin-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'sixin',
    portrait: 'sixin',
    text: '规则清单背面是空的。我想加一句不管用但应该存在的话。问题是，不管用的话通常最受欢迎，比如“大家自觉”。',
    background: 'warRoom',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedSixin' }],
    choices: [
      {
        id: 'write-sixin-human-rule',
        label: '写下：“犯错的人也有改正的下一次。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'sixin', key: 'trust', value: 2 },
          { type: 'relationship', character: 'sixin', key: 'affinity', value: 1 },
        ],
        next: 'r2-30w-sixin-keeps-rule',
      },
      {
        id: 'write-sixin-rest-rule',
        label: '写下：“凌晨一点以后，规则起草人先睡。”',
        tone: 'warm',
        effects: [{ type: 'relationship', character: 'sixin', key: 'affinity', value: 2 }],
        next: 'r2-30x-sixin-obeys-rest-rule',
      },
    ],
  },
  {
    id: 'r2-30w-sixin-keeps-rule',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'sixin',
    portrait: 'sixin',
    text: '这句可以。前提是“下一次”不能自动清空上一次的后果。规则不是门锁，更像账本——难看，但得让人翻得到。',
    background: 'warRoom',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30x-sixin-obeys-rest-rule',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 战备室',
    mode: 'chat',
    speaker: 'sixin',
    portrait: 'sixin',
    text: '刚写就针对起草人，说明规则至少公平。那我先执行，你负责监督；要是你两点还在线，我明天补一条首领罚则。',
    background: 'warRoom',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30y-xilufei-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '管理员速成课第一章：先说自己是老区高层。第二章：拿到权限。第三章我还没写，因为一般到这里群就没了。',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedXilufei' }],
    choices: [
      {
        id: 'delete-xilufei-guide',
        label: '按住删除键：“教材没收，作者保留观察。”',
        tone: 'calm',
        effects: [
          { type: 'relationship', character: 'xilufei', key: 'trust', value: 1 },
          { type: 'relationship', character: 'xilufei', key: 'affinity', value: 1 },
          { type: 'relationshipProgress', character: 'xilufei', value: 30 },
        ],
        next: 'r2-30z-xilufei-surrenders-guide',
      },
      {
        id: 'rewrite-xilufei-harmless-prank',
        label: '“重写。只准教人把群名改成‘禁止改群名’。”',
        tone: 'secret',
        effects: [
          { type: 'relationship', character: 'xilufei', key: 'affinity', value: 2 },
          { type: 'relationshipProgress', character: 'xilufei', value: 30 },
        ],
        next: 'r2-30aa-xilufei-rewrites-guide',
      },
    ],
  },
  {
    id: 'r2-30z-xilufei-surrenders-guide',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '行，观察对象申请一杯奶茶。你放心，我现在对管理员按钮过敏，一看见就想起自己还欠一群人的重新加群申请。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30aa-xilufei-rewrites-guide',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'xilufei',
    portrait: 'xilufei',
    text: '这个有品。第四章就写“改回来的人请在群里公开承认自己认真看了群名”。放心，最多伤害三个人的自尊。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30ab-saoji-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '我没关麦，是怕一静下来又像在等别人说“你不适合这里”。以前被一组排斥时，我连退群提示都反复看了三遍，确认不是网络延迟。',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedSaoji' }],
    choices: [
      {
        id: 'tell-saoji-no-audition',
        label: '“这里不收试镜费。想说就说，想静音也没人赶你。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'saoji', key: 'trust', value: 2 },
          { type: 'relationship', character: 'saoji', key: 'affinity', value: 1 },
        ],
        next: 'r2-30ac-saoji-mutes-safely',
      },
      {
        id: 'stay-on-mic-with-saoji',
        label: '把自己的麦也打开：“那就一起挂着。”',
        tone: 'warm',
        effects: [{ type: 'relationship', character: 'saoji', key: 'affinity', value: 2 }],
        next: 'r2-30ad-saoji-keeps-company',
      },
    ],
  },
  {
    id: 'r2-30ac-saoji-mutes-safely',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '那我试试静音。……看，头像还在。原来有些群里，闭嘴不等于消失。明天我会上线，这句不用你写进公告。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30ad-saoji-keeps-company',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'saoji',
    portrait: 'saoji',
    text: '行。我们谁都不必说话，背景里有键盘声就够了。要是有人问，就说这是江南最新的双人战术：互相证明没掉线。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30ae-haogeju-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'haogeju',
    portrait: 'haogeju',
    text: '今晚需要一首片尾曲。要求：不能像庆功，不能像散伙，也不能让夏娜听完误以为明天要宣战。曲库说符合条件的歌有零首。',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedHaogeju' }],
    choices: [
      {
        id: 'choose-haogeju-quiet-song',
        label: '“放一首适合还没下线的人听的。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'haogeju', key: 'trust', value: 1 },
          { type: 'relationship', character: 'haogeju', key: 'affinity', value: 1 },
        ],
        next: 'r2-30af-haogeju-plays-quiet-song',
      },
      {
        id: 'ask-haogeju-sing',
        label: '“曲库不行就你来唱，唱跑调也算原创。”',
        tone: 'warm',
        effects: [{ type: 'relationship', character: 'haogeju', key: 'affinity', value: 2 }],
        next: 'r2-30ag-haogeju-sings',
      },
    ],
  },
  {
    id: 'r2-30af-haogeju-plays-quiet-song',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'haogeju',
    portrait: 'haogeju',
    text: '找到了。没有副歌，没人在最高处喊名字，适合把今天放下又不急着总结。你听完再走，我保证不切战歌。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30ag-haogeju-sings',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'haogeju',
    portrait: 'haogeju',
    text: '你说的，跑调算原创。等会儿有人投诉，你负责用首领权限宣布这是实验音乐——放心，只用来保护艺术，不用来禁言。',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30ah-lan-night-talk',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'lan',
    portrait: 'lan',
    text: '蓝把一张红白请柬拖进聊天框，又在发送前停住。蓝说这是明晚活动邀请：“江南最近每次集合都像参加自己的追悼会，我想让大家至少穿得喜庆一点。”',
    background: 'nightMessage',
    historical: 'fictional',
    onEnter: [{ type: 'flag', key: 'r2NightVisitedLan' }],
    choices: [
      {
        id: 'rewrite-lan-invitation',
        label: '接过请柬：“标题改成‘活着回来’，然后发。”',
        tone: 'warm',
        effects: [
          { type: 'relationship', character: 'lan', key: 'trust', value: 2 },
          { type: 'relationship', character: 'lan', key: 'affinity', value: 1 },
        ],
        next: 'r2-30ai-lan-sends-invitation',
      },
      {
        id: 'protect-lan-invitation',
        label: '按住发送键：“先私发我，夏娜会把它当宣战书。”',
        tone: 'secret',
        effects: [
          { type: 'relationship', character: 'lan', key: 'trust', value: 1 },
          { type: 'relationship', character: 'lan', key: 'affinity', value: 2 },
        ],
        next: 'r2-30aj-lan-shares-preview',
      },
    ],
  },
  {
    id: 'r2-30ai-lan-sends-invitation',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'lan',
    portrait: 'lan',
    text: '成交。蓝改完标题按下发送，群里先回了十一个问号，接着是一排“1”。蓝笑了：“看，问号也是出勤，至少人都还活着。”',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30aj-lan-shares-preview',
    chapter: 'epilogue',
    actLabel: '尾声 · 江南夜话',
    date: '2026-07-28',
    location: '江南 · 深夜语音房',
    mode: 'chat',
    speaker: 'lan',
    portrait: 'lan',
    text: '那你是第一位宾客。蓝把预览只发给你，末尾偷偷加了一行小字：“允许迟到，禁止失踪；首领也算。”',
    background: 'nightMessage',
    historical: 'fictional',
    next: 'r2-30-member-night-hub',
  },
  {
    id: 'r2-30-bond-router',
    chapter: 'epilogue',
    actLabel: '尾声 · 私聊窗口',
    date: '2026-07-28',
    location: '深夜私聊',
    mode: 'novel',
    speaker: 'narrator',
    text: '管理页已经合上，几扇私聊窗口却还亮着。今晚它们没有先后之分，也没有人会因为消息更早送达就先得到回答。你可以亲手点开一个名字，也可以让关系停在普通朋友。',
    background: 'nightMessage',
    historical: 'fictional',
    choices: [
      {
        id: 'choose-bond-swordheart',
        label: '“明晚提前十分钟，我想先见剑斩凡人心。”',
        tone: 'warm',
        condition: {
          type: 'all',
          conditions: [
            { type: 'flag', key: 'swordheartRosterChecked' },
            { type: 'flag', key: 'swordheartReconnectedRoster' },
            { type: 'flag', key: 'swordheartLastCheck' },
            { type: 'relationshipProgress', character: 'swordheart', operator: 'gte', value: 100 },
            { type: 'relationship', character: 'swordheart', key: 'trust', operator: 'gte', value: 6 },
            { type: 'relationship', character: 'swordheart', key: 'affinity', operator: 'gte', value: 5 },
          ],
        },
        next: 'r2-31-bond-swordheart',
      },
      {
        id: 'choose-bond-xilufei',
        label: '“下个新区的暗号，我只回给希露菲。”',
        tone: 'secret',
        condition: {
          type: 'all',
          conditions: [
            { type: 'flag', key: 'xilufeiAccomplice' },
            { type: 'relationshipProgress', character: 'xilufei', operator: 'gte', value: 100 },
            { type: 'relationship', character: 'xilufei', key: 'trust', operator: 'gte', value: 3 },
            { type: 'relationship', character: 'xilufei', key: 'affinity', operator: 'gte', value: 3 },
          ],
        },
        next: 'r2-31-bond-xilufei',
      },
      {
        id: 'choose-bond-shana',
        label: '“今晚不谈开战，我想和夏娜多聊一会。”',
        tone: 'warm',
        condition: {
          type: 'all',
          conditions: [
            { type: 'relationshipProgress', character: 'shana', operator: 'gte', value: 100 },
            { type: 'relationship', character: 'shana', key: 'trust', operator: 'gte', value: 3 },
            { type: 'relationship', character: 'shana', key: 'affinity', operator: 'gte', value: 3 },
          ],
        },
        next: 'r2-31-bond-shana',
      },
      {
        id: 'choose-bond-takemehand',
        label: '“我愿意等takemehand把下一句话说完。”',
        tone: 'warm',
        condition: {
          type: 'all',
          conditions: [
            { type: 'relationshipProgress', character: 'takemehand', operator: 'gte', value: 100 },
            { type: 'relationship', character: 'takemehand', key: 'trust', operator: 'gte', value: 2 },
            { type: 'relationship', character: 'takemehand', key: 'affinity', operator: 'gte', value: 2 },
          ],
        },
        next: 'r2-31-bond-takemehand',
      },
      {
        id: 'choose-bond-chenyi',
        label: '点开辰逸留下的私人联系方式：“不谈职位，谈我们。”',
        tone: 'warm',
        condition: {
          type: 'all',
          conditions: [
            { type: 'relationshipProgress', character: 'chenyi', operator: 'gte', value: 100 },
            { type: 'relationship', character: 'chenyi', key: 'trust', operator: 'gte', value: 2 },
            { type: 'relationship', character: 'chenyi', key: 'affinity', operator: 'gte', value: 3 },
          ],
        },
        next: 'r2-31-bond-chenyi',
      },
      {
        id: 'keep-ordinary-bonds',
        label: '给所有亮着的头像道晚安，保持普通关系',
        tone: 'calm',
        next: 'r2-32-world-router',
      },
    ],
  },
  bondEndingNode({
    id: 'r2-31-bond-swordheart',
    actLabel: '尾声 · 最后一格出勤',
    location: '江南 · 战备室',
    character: 'swordheart',
    text: '出勤表最后一格我替你核完了。你没给我管理员，也没拿“精英”两个字哄我；很好，省得我还要退权限。明晚八点我照常上线。你要是早到十分钟……那十分钟可以只留给你。',
    cg: cgPath('cg43-bond-swordheart'),
    cgAlt: '深夜战备室里，剑斩凡人心合上核完的出勤表，为玩家留出身旁的位置与明晚提前上线的十分钟',
    cgId: 'cg43-bond-swordheart',
    focus: 'right',
    next: 'r2-32-world-router',
  }),
  bondEndingNode({
    id: 'r2-31-bond-xilufei',
    actLabel: '尾声 · 下一个新区',
    location: '未知群聊',
    character: 'xilufei',
    text: '你后来把公告写得挺像首领。可我更喜欢你没写进公告的那部分。下个新区还来吗？这次我们先决定，谁假装不认识谁。',
    cg: cgPath('cg22-bond-xilufei'),
    cgAlt: '服务器交界的秘密房间里，希露菲把两张空白身份卡和两部手机放在玩家面前，约定下个新区假装不认识',
    cgId: 'cg22-bond-xilufei',
    transition: 'glitch',
    atmosphere: 'messages',
    next: 'r2-32-world-router',
  }),
  bondEndingNode({
    id: 'r2-31-bond-shana',
    actLabel: '尾声 · 不为开战的私聊',
    location: '江南 · 私聊',
    character: 'shana',
    text: '首领今天处理得还行。以后不只在要开战时找我。……上线也可以，聊天也可以。决定还是你来。',
    cg: cgPath('cg16-bond-shana'),
    cgAlt: '夜晚的江南组织房间里，夏娜将热茶推向玩家，邀请对方不为开战也来找她',
    cgId: 'cg16-bond-shana',
    next: 'r2-32-world-router',
  }),
  bondEndingNode({
    id: 'r2-31-bond-takemehand',
    actLabel: '尾声 · 等一会',
    location: '私聊',
    character: 'takemehand',
    text: '我留下的不是那张禁言截图，是你后来真的照规则做了。下次有人不回消息，先来问我。要是我也不回……你可以等我一会。',
    cg: cgPath('cg21-bond-takemehand'),
    cgAlt: '深夜语音房里，takemehand展示晚了两分钟的回复，远处的管理员禁言按钮始终没有被触碰',
    cgId: 'cg21-bond-takemehand',
    atmosphere: 'messages',
    next: 'r2-32-world-router',
  }),
  bondEndingNode({
    id: 'r2-31-bond-chenyi',
    actLabel: '尾声 · 权限之外',
    location: '辰逸 · 私人语音',
    character: 'chenyi',
    text: '我不会说“因为喜欢你才做错事”，那样只是给错误换个好听的头像。禁言、争吵、降级，都是我该承担的。职位已经留在江南了；如果你还愿意认识权限以外的我，我想从一条不用你立刻回复的消息开始。',
    cg: cgPath('cg46-bond-chenyi'),
    cgAlt: '辰逸在离开江南职位后关掉管理员界面，只留下没有催促回复的私人消息，与玩家从权限之外重新认识彼此',
    cgId: 'cg46-bond-chenyi',
    atmosphere: 'messages',
    next: 'r2-32-world-router',
  }),
  {
    id: 'r2-32-world-router',
    chapter: 'epilogue',
    actLabel: '尾声 · 最后一条群消息',
    date: '2026-07-28',
    location: '江南组织群',
    mode: 'chat',
    speaker: 'sixin',
    portrait: 'sixin',
    text: '今天的表我收完了。明晚八点还打，能来的回个1。',
    background: 'ending',
    next: {
      cases: [
        // ── 蝴蝶效应 · 路线变体结局 ──
        { when: { type: 'flag', key: 'bf_ruthless' }, next: 'r2-end-tyrant' },
        { when: { type: 'flag', key: 'bf_peacemaker' }, next: 'r2-end-peacemaker' },
        { when: { type: 'flag', key: 'bf_opportunist' }, next: 'r2-end-lonely' },
        // ── 数值分流（原有逻辑）──
        { when: { type: 'stat', key: 'cohesion', operator: 'lte', value: 1 }, next: 'r2-end-alone' },
        {
          when: {
            type: 'all',
            conditions: [
              { type: 'stat', key: 'resources', operator: 'gte', value: 4 },
              { type: 'stat', key: 'reputation', operator: 'lte', value: -1 },
            ],
          },
          next: 'r2-end-war-machine',
        },
        {
          when: {
            type: 'all',
            conditions: [
              { type: 'stat', key: 'cohesion', operator: 'gte', value: 3 },
              { type: 'stat', key: 'reputation', operator: 'gte', value: 0 },
            ],
          },
          next: 'r2-end-second-pole',
        },
      ],
      fallback: 'r2-end-won-lost-chat',
    },
  },
  {
    id: 'r2-end-second-pole',
    chapter: 'epilogue',
    actLabel: '尾声 · 克制的第二极',
    date: '2026-07-28',
    title: '克制的第二极',
    location: '4945区',
    mode: 'ending',
    speaker: 'narrator',
    text: '江南没有取代一组，也没有靠永远开战证明存在。外界仍会质疑二组，但他们开始承认：这里的高层权限受规则约束，首领说过的话会在下一次事件里继续算数。4945区有了第二个中心。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg34-ending-route2'),
      cgAlt: '江南清晨的管理室里，胜利旗、首领印和仍有人使用的普通座椅共同构成克制的第二极',
      ui: 'ending',
      transition: 'crossfade',
      camera: 'pull-back',
      atmosphere: 'none',
      focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r2-second-pole' },
      { type: 'unlockCg', id: 'cg34-ending-route2' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r2-end-war-machine',
    chapter: 'epilogue',
    actLabel: '尾声 · 战争机器',
    date: '2026-07-28',
    title: '战争机器',
    location: '4945区',
    mode: 'ending',
    speaker: 'narrator',
    text: '江南的出勤表漂亮得像一份威慑声明。成员愿意打，资源也够用，只是每个新群都默认把二组设成假想敌。你赢得了让所有人认真对待你的能力，也失去了让他们放松说话的空间。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg34-ending-route2'),
      cgAlt: '江南管理室仍挂着胜利旗，首领王座和空掉的普通折叠椅让高效率显得格外安静',
      ui: 'ending',
      transition: 'flash',
      camera: 'push-in',
      atmosphere: 'embers',
      focus: 'left',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r2-war-machine' },
      { type: 'unlockCg', id: 'cg34-ending-route2' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r2-end-won-lost-chat',
    chapter: 'epilogue',
    actLabel: '尾声 · 赢了要塞，输了群',
    date: '2026-07-28',
    title: '赢了要塞，输了群',
    location: '4945区',
    mode: 'ending',
    speaker: 'narrator',
    text: '江南仍有战果，群里却越来越少有人主动说话。规章、战书和辟谣都很完整，只有“今晚谁想一起玩”没有人接。组织没有解散，只是公共生活先一步退出了。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg34-ending-route2'),
      cgAlt: '火2仍在江南窗外，管理室的胜利旗亮着，群聊灯却只剩一个微弱气泡',
      ui: 'ending',
      transition: 'crossfade',
      camera: 'drift-left',
      atmosphere: 'messages',
      focus: 'right',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r2-won-lost-chat' },
      { type: 'unlockCg', id: 'cg34-ending-route2' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r2-end-alone',
    chapter: 'epilogue',
    actLabel: '尾声 · 只有首领没退群',
    date: '2026-07-28',
    title: '只有首领没退群',
    location: '江南成员列表',
    mode: 'ending',
    speaker: 'narrator',
    text: '职位还在，组织页面也在。你每次都守住了“首领有权决定”，却没留下愿意共同承担决定的人。系统依然称你为江南首领——系统一向很尊重没有被点击转让的职位。',
    background: 'ending',
    music: 'afterOnline',
    presentation: {
      cg: cgPath('cg34-ending-route2'),
      cgAlt: '黎明照进江南管理室，首领印仍在桌上，王座与所有普通椅子都无人使用',
      ui: 'ending',
      transition: 'crossfade',
      camera: 'pull-back',
      atmosphere: 'dust',
      focus: 'left',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r2-alone' },
      { type: 'unlockCg', id: 'cg34-ending-route2' },
    ],
    next: 'worldline-check',
  },

  // ──────────────── 蝴蝶效应 · 变体结局 ────────────────
  {
    id: 'r2-end-tyrant',
    chapter: 'epilogue', actLabel: '终幕 · 霸王', date: '2026-07-28',
    title: '霸王', location: '4945区', mode: 'ending', speaker: 'narrator',
    text: '江南以无可辩驳的数字站在前列。没有人再质疑你的决定——不是因为信服，而是因为每一个质疑的代价都已被计算过。权力从未如此稳定，也从未如此安静。',
    background: 'ending', music: 'afterOnline',
    presentation: {
      cg: cgPath('cg34-ending-route2'),
      cgAlt: '江南管理室里只剩首领王座亮着灯，所有折叠椅被收拢到角落，墙上火2战报如阴影',
      ui: 'ending-dark', transition: 'flash', camera: 'push-in', atmosphere: 'embers', focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r2-tyrant' },
      { type: 'unlockCg', id: 'cg34-ending-route2' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r2-end-peacemaker',
    chapter: 'epilogue', actLabel: '终幕 · 调停者', date: '2026-07-28',
    title: '调停者', location: '4945区', mode: 'ending', speaker: 'narrator',
    text: '江南以调停而非征服确立存在。其他组织可能不会承认你们是领导者，但每次冲突爆发前，总有人先私信你——不是请求支援，而是问"你觉得怎么处理"。权力穿上了外交的外衣，但仍然在桌下握着剑。',
    background: 'ending', music: 'afterOnline',
    presentation: {
      cg: cgPath('cg34-ending-route2'),
      cgAlt: '六把椅子环坐江南管理室圆桌，首领印与和平协议并排放置，窗外火2已熄',
      ui: 'ending-triumph', transition: 'crossfade', camera: 'pull-back', atmosphere: 'petals', focus: 'center',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r2-peacemaker' },
      { type: 'unlockCg', id: 'cg34-ending-route2' },
    ],
    next: 'worldline-check',
  },
  {
    id: 'r2-end-lonely',
    chapter: 'epilogue', actLabel: '终幕 · 孤城', date: '2026-07-28',
    title: '孤城', location: '4945区', mode: 'ending', speaker: 'narrator',
    text: '你凭借每一次形势的判断留在了高位，却失去了愿意在深夜群里接你话题的人。群聊列表仍显示在线人数，只是当你开口时，回复是你自己发出的，两次撤回之间的沉默。组织没有失败，只是不再被需要。',
    background: 'ending', music: 'afterOnline',
    presentation: {
      cg: cgPath('cg34-ending-route2'),
      cgAlt: '江南管理室灯光黯淡，首领椅独自亮着，折叠椅全部空置，窗外没有火2火光',
      ui: 'ending-lament', transition: 'slide', camera: 'drift-left', atmosphere: 'dust', focus: 'left',
    },
    onEnter: [
      { type: 'unlockEnding', id: 'r2-lonely' },
      { type: 'unlockCg', id: 'cg34-ending-route2' },
    ],
    next: 'worldline-check',
  },
] satisfies StoryNode[]
